<template>
    <!-- 文件管理 -->
    <div class="lite-file">
        <div id="liteFileElement" style="display:none;"></div>
        <!-- 云盘列表 -->
        <div class="lite-drive-box" v-if="!$store.state.curDriveId">
            <div class="lite-drive-box-btns" v-show="false">
                <button @click="addCloud()" class="addCloudIcon addCloudIconLite">{{$t('language.common.addCloud')}}</button>
            </div>
            <div class="lite-drive-items myscroll">
                <!-- 有空间的云盘 -->
                <div :title="drive.errorMsg" :class="'lite-drive-item' + (curCloudId==drive.id?' lite-drive-item-select':'')" v-for="drive in spaceDrives" :key="drive.id" @dblclick="openDrive(drive.id)" @click="curCloudId=drive.id">
                    <div :class="'drive-item-icon drive-icon-' + drive.type"></div>
                    <div class="drive-item-info">
                        <div class="drive-item-name">{{ drive.name }}</div>
                        <div class="drive-item-prog">
                            <div class="drive-item-prog-item" :style="{width:getDriveSpace(drive),backgroundColor:getDriveSpaceColor(drive)}"></div>
                        </div>
                        <div class="drive-item-space">
                            <span>{{ getDriveInfo(drive) }}</span>
                        </div>
                        <el-link @click.stop="loadDriveInfo(drive)" class="drive-item-load" :icon="drive.loadDriveInfo ? 'el-icon-loading' : 'el-icon-refresh-right'" :underline="false"></el-link>
                    </div>
                </div>
                <!-- 分割线 -->
                <div class="lite-drive-item-line" v-if="noSpaceDrives.length > 0"></div>
                <!-- 无空间 -->
                <div :class="'lite-drive-item lite-drive-item-no-space' + (curCloudId==drive.id?' lite-drive-item-select':'')" v-for="drive in noSpaceDrives" :key="drive.id" @dblclick="openDrive(drive.id)" @click="curCloudId=drive.id">
                    <div :class="'drive-item-icon drive-icon-' + drive.type"></div>
                    <div class="drive-item-name">{{ drive.name }}</div>
                </div>
            </div>
            <!-- 云盘类型个数统计 -->
            <div class="lite-drive-footer">
                <div class="drive-count">Clouds: {{ $store.state.drives.length - countFTP - countWebDAV - countDB }}</div>
                <div class="drive-count">FTP: {{ countFTP }}</div>
                <div class="drive-count">WebDAV: {{ countWebDAV }}</div>
                <div class="drive-count">DB: {{ countDB }}</div>
                <button @click="loadAllDriveInfo()" v-show="false">Load All Drive Info</button>
            </div>
        </div>
        <div class="lite-file-box" ref="fileDropZone" v-else
            @dragenter="onUploadDragEnter" @dragover="onUploadDragOver" @dragleave="onUploadDragLeave" @drop="onDrop">
            <div v-if="dragUploadEnabled && isUploadDragOver" class="lite-file-drop-overlay" :class="{'is-disabled': !canAcceptUploadDrop()}" aria-live="polite">
                <i :class="canAcceptUploadDrop() ? 'el-icon-upload' : 'el-icon-circle-close'"></i>
                <span>{{ $t('language.common.' + (canAcceptUploadDrop() ? 'dropFilesToUpload' : 'uploadUnavailable')) }}</span>
            </div>
            <!-- 导航 -->
            <el-breadcrumb class="folder-nav" separator-class="el-icon-arrow-right" v-if="$store.state.curDriveId">
                <!-- 主页 -->
                <el-breadcrumb-item>
                    <span class="folder-nav-home home-page-icon" @click="showDrives()"></span>
                </el-breadcrumb-item>
                <!-- 云盘 -->
                <el-breadcrumb-item>
                    <span class="folder-nav-span" @click="openFolder($store.state.curDriveId, null, null)" :title="getDrive($store.state.curDriveId).name">{{ getDrive($store.state.curDriveId).name }}</span>
                </el-breadcrumb-item>
                <!-- 文件夹 -->
                <el-breadcrumb-item v-for="node in getNodeArr($store.state.curNode)" :key="node.id">
                    <span class="folder-nav-span" @click="openFolder($store.state.curDriveId, node, null)" :title="node.name">{{ node.name }}</span>
                </el-breadcrumb-item>
            </el-breadcrumb>
            <!-- 右键菜单 -->
            <div ref="rightMenu" class="right-menus" v-if="showRightMenu" :style="{ left: rightMenuX + 'px', top: rightMenuY + 'px' }">
                <div class="options-button" v-show="showUpload()" @click="triggerUpload()">
                    <div class="options-button-icon lite-upload"></div>
                    <div class="options-button-text">{{ $t('language.cloudExploer.uploadFile') }}</div>
                </div>
                <div class="options-button" v-show="showBucket()" @click="triggerBucket()">
                    <div class="options-button-icon lite-bucket"></div>
                    <div class="options-button-text">{{ $t('language.cloudExploer.newBucket') }}</div>
                </div>
                <div class="options-button" v-show="showMkdir()" @click="triggerMkdir()">
                    <div class="options-button-icon lite-mkdir"></div>
                    <div class="options-button-text">{{ $t('language.cloudExploer.newFolder') }}</div>
                </div>
                <div class="options-button" v-show="showTranTo()" @click="selectTaskTo('tran')">
                    <div class="options-button-icon copy-to"></div>
                    <div class="options-button-text">{{ $t('language.common.tranTo') }}</div>
                </div>
                <div class="options-button" v-show="showSyncWith()" @click="selectTaskTo('sync')">
                    <div class="options-button-icon lite-sync-with"></div>
                    <div class="options-button-text">{{ $t('language.common.syncWith') }}</div>
                </div>
                <div class="options-button" v-show="showBackupTo()" @click="selectTaskTo('backup')">
                    <div class="options-button-icon lite-backup-to"></div>
                    <div class="options-button-text">{{ $t('language.common.backupTo') }}</div>
                </div>
                <div class="options-button" v-show="showDownload()" @click="downLoadFile()">
                    <div class="options-button-icon lite-download"></div>
                    <div class="options-button-text">{{ $t('language.common.download') }}</div>
                </div>
                <div class="options-button" v-show="showCut()" @click="cutFile()">
                    <div class="options-button-icon lite-cut"></div>
                    <div class="options-button-text">{{ $t('language.common.cut') }}</div>
                </div>
                <div class="options-button" v-show="showDelete()" @click="deleteFile()">
                    <div class="options-button-icon lite-delete"></div>
                    <div class="options-button-text">{{ $t('language.common.delete') }}</div>
                </div>
                <div class="options-button" v-show="showPreview()" @click="previewFile()">
                    <div class="options-button-icon lite-preview"></div>
                    <div class="options-button-text">{{ $t('language.common.preview') }}</div>
                </div>
                <div class="options-button" v-show="showRename()" @click="renameFile()">
                    <div class="options-button-icon lite-rename"></div>
                    <div class="options-button-text">{{ $t('language.common.rename') }}</div>
                </div>
                <div class="options-button" v-show="showCopy()" @click="copyFile()">
                    <div class="options-button-icon lite-copy"></div>
                    <div class="options-button-text">{{ $t('language.common.copy') }}</div>
                </div>
                <div class="options-button" v-show="showPaste()" @click="pasteFile()">
                    <div class="options-button-icon lite-paste"></div>
                    <div class="options-button-text">{{ $t('language.common.paste') }}</div>
                </div>
                <div class="options-button" v-show="showNext()" @click="loadNext()">
                    <div class="options-button-icon lite-next"></div>
                    <div class="options-button-text">{{ $t('language.imageSaver.loadMore') }}</div>
                </div>
            </div>
            <!-- 右边操作按钮 -->
            <div class="options-buttons-right">
                <button v-if="gridViewEnabled" type="button" class="file-view-toggle" @click="toggleFileView"
                    :title="$t('language.common.' + (fileView === 'list' ? 'gridView' : 'listView'))"
                    :aria-label="$t('language.common.' + (fileView === 'list' ? 'gridView' : 'listView'))">
                    <i :class="fileView === 'list' ? 'el-icon-menu' : 'el-icon-s-operation'" aria-hidden="true"></i>
                </button>
                <div class="refresh" @click="refresh()"></div>
            </div>
            <!-- 操作按钮 -->
            <div :class="'options-buttons' + (this.multipleSelection.length>0 ? ' has-border' : '')">
                <input type="file" ref="fileInput" multiple @change="handleFileChange" style="display:none">
                <div style="height:20px;width:0px;display:inline-block;"></div>
                <div class="options-button" v-show="showBucket()" @click="triggerBucket()">
                    <div class="options-button-icon lite-bucket"></div>
                    <div class="options-button-text">{{ $t('language.cloudExploer.newBucket') }}</div>
                </div>
                <div class="options-button" v-show="showAddPhotos()" @click="triggerAddPhotos()">
                    <div class="options-button-icon add-more-photos-icon"></div>
                    <div class="options-button-text">{{ $t('language.popup.cloudExploerPopup.googlePhotosV2AddMore') }}</div>
                </div>
                <div class="options-button" v-show="showUpload()" @click="triggerUpload()">
                    <div class="options-button-icon lite-upload"></div>
                    <div class="options-button-text">{{ $t('language.cloudExploer.uploadFile') }}</div>
                </div>
                <div class="btn-space" v-if="showUpload() && showMkdir()"></div>
                <div class="options-button" v-show="showMkdir()" @click="triggerMkdir()">
                    <div class="options-button-icon lite-mkdir"></div>
                    <div class="options-button-text">{{ $t('language.cloudExploer.newFolder') }}</div>
                </div>
                <div class="btn-space" v-if="showTranTo()"></div>
                <div class="options-button" v-show="showTranTo()" @click="selectTaskTo('tran')">
                    <div class="options-button-icon copy-to"></div>
                    <div class="options-button-text">{{ $t('language.common.tranTo') }}</div>
                </div>
                <div class="btn-space" v-if="showSyncWith()"></div>
                <div class="options-button" v-show="showSyncWith()" @click="selectTaskTo('sync')">
                    <div class="options-button-icon lite-sync-with"></div>
                    <div class="options-button-text">{{ $t('language.common.syncWith') }}</div>
                </div>
                <div class="btn-space" v-if="showBackupTo()"></div>
                <div class="options-button" v-show="showBackupTo()" @click="selectTaskTo('backup')">
                    <div class="options-button-icon lite-backup-to"></div>
                    <div class="options-button-text">{{ $t('language.common.backupTo') }}</div>
                </div>
                <div class="btn-space" v-if="showDownload()"></div>
                <div class="options-button" v-show="showDownload()" @click="downLoadFile()">
                    <div class="options-button-icon lite-download"></div>
                    <div class="options-button-text">{{ $t('language.common.download') }}</div>
                </div>
                <div class="btn-space" v-if="showCut()"></div>
                <div class="options-button" v-show="showCut()" @click="cutFile()">
                    <div class="options-button-icon lite-cut"></div>
                    <div class="options-button-text">{{ $t('language.common.cut') }}</div>
                </div>
                <div class="btn-space" v-if="showDelete()"></div>
                <div class="options-button" v-show="showDelete()" @click="deleteFile()">
                    <div class="options-button-icon lite-delete"></div>
                    <div class="options-button-text">{{ $t('language.common.delete') }}</div>
                </div>
                <div class="btn-space" v-if="showPreview()"></div>
                <div class="options-button" v-show="showPreview()" @click="previewFile()">
                    <div class="options-button-icon lite-preview"></div>
                    <div class="options-button-text">{{ $t('language.common.preview') }}</div>
                </div>
                <div class="btn-space" v-if="showRename()"></div>
                <div class="options-button" v-show="showRename()" @click="renameFile()">
                    <div class="options-button-icon lite-rename"></div>
                    <div class="options-button-text">{{ $t('language.common.rename') }}</div>
                </div>
                <div class="btn-space" v-if="showCopy()"></div>
                <div class="options-button" v-show="showCopy()" @click="copyFile()">
                    <div class="options-button-icon lite-copy"></div>
                    <div class="options-button-text">{{ $t('language.common.copy') }}</div>
                </div>
                <div class="btn-space" v-if="showPaste()"></div>
                <el-tooltip effect="light" placement="bottom">
                    <template slot="content">
                        <div class="copy_nodes myscroll">
                            <div class="copy_node" v-for="(copyNode,index) in copyNodes" :key="copyNode.id">
                                <div class="copy_node_name" v-if="copyNode.dir">
                                    <b class="copy_node_index">{{ index+1 }}</b>
                                    <img class="lite-file-icon" :src="'/static/file/'+getNodeIcon(copyNode)+'.svg'" @error="e => e.target.src = '/static/file/file.svg'" draggable="false" />
                                    <b>{{ copyNode.name }}</b>
                                </div>
                                <div class="copy_node_name" v-else>
                                    <b class="copy_node_index">{{ index+1 }}</b>
                                    <img class="lite-file-icon" :src="'/static/file/'+getNodeIcon(copyNode)+'.svg'" @error="e => e.target.src = '/static/file/file.svg'" draggable="false" />
                                    <span>{{ copyNode.name }}</span>
                                </div>
                                <div class="copy_node_size">{{ formatBytes(copyNode.size) }}</div>
                            </div>
                        </div>
                    </template>
                    <div class="options-button" v-show="showPaste()" @click="pasteFile()">
                        <div class="options-button-icon lite-paste"></div>
                        <div class="options-button-text">{{ $t('language.common.paste') }}</div>
                    </div>
                </el-tooltip>
                <div class="btn-space" v-if="showNext()"></div>
                <div class="options-button" v-show="showNext()" @click="loadNext()">
                    <div class="options-button-icon lite-next"></div>
                    <div class="options-button-text">{{ $t('language.imageSaver.loadMore') }}</div>
                </div>
            </div>
            <!-- 表格 -->
            <el-table v-show="fileView === 'list'" class="lite-file-table" :data="orderedFiles" ref="filesTable" empty-text=" "
                :cell-class-name="liteFileCellClass" @row-dblclick="onRowDbClick"
                @row-click="onRowClick" @row-contextmenu="onRowRightClick" @contextmenu.native.prevent="onTableRightClick"
                stripe height="600px" @selection-change="handleSelectionChange" @select="onTableSelect" @sort-change="onFileSortChange">
                <el-table-column type="selection" width="42" align="center" header-align="center"></el-table-column>
                <el-table-column prop="name" :label="$t('language.common.fileName')" min-width="336px" show-overflow-tooltip sortable="custom">
                    <template slot-scope="scope">
                        <div>
                            <img class="lite-file-icon" :src="'/static/file/'+getNodeIcon(scope.row)+'.svg'" @error="e => e.target.src = '/static/file/file.svg'" draggable="false" />
                            <span class="lite-file-name" @click.stop="onFileNameClick(scope.row, $event)">{{ scope.row.name }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="size" :label="$t('language.common.size')" sortable="custom">
                    <template slot-scope="scope">
                        {{ formatBytes(scope.row.size) }}
                    </template>
                </el-table-column>
                <el-table-column prop="time" min-width="130px" :label="$t('language.common.dateModified')" sortable="custom">
                    <template slot-scope="scope">
                        {{ formatDate(scope.row.time) }}
                    </template>
                </el-table-column>
            </el-table>
            <!-- 网格与列表共享文件和选择状态；保留表格以保留排序。 -->
            <div v-if="gridViewEnabled && fileView === 'grid'" class="lite-file-grid-view" @contextmenu.prevent="onTableRightClick">
                <div class="lite-file-grid-toolbar">
                    <el-checkbox :value="curResult.length > 0 && multipleSelection.length === curResult.length"
                        :indeterminate="multipleSelection.length > 0 && multipleSelection.length < curResult.length"
                        :disabled="!curResult.length" @change="selectAll">{{ $t('language.common.selectAll') }}</el-checkbox>
                    <select class="lite-file-grid-sort" :value="fileSort.prop" @change="sortGridFiles($event.target.value)"
                        :aria-label="$t('language.common.sortBy')">
                        <option value="">{{ $t('language.common.sortBy') }}</option>
                        <option value="name">{{ $t('language.common.fileName') }}</option>
                        <option value="size">{{ $t('language.common.size') }}</option>
                        <option value="time">{{ $t('language.common.dateModified') }}</option>
                    </select>
                    <button class="lite-file-sort-direction" type="button" :disabled="!fileSort.prop"
                        :title="$t('language.common.' + (fileSort.order === 'ascending' ? 'descending' : 'ascending'))"
                        :aria-label="$t('language.common.' + (fileSort.order === 'ascending' ? 'descending' : 'ascending'))"
                        @click="sortGridFiles(fileSort.prop, fileSort.order === 'ascending' ? 'descending' : 'ascending')">
                        <i :class="fileSort.order === 'descending' ? 'el-icon-sort-down' : 'el-icon-sort-up'"></i>
                    </button>
                </div>
                <div ref="fileGrid" class="lite-file-grid myscroll" tabindex="0" role="listbox" aria-multiselectable="true"
                    :aria-label="$t('language.common.gridView')" @mousedown="startGridSelection" @keydown="onGridKeyDown">
                    <div class="lite-file-grid-items">
                        <div v-for="(file, index) in orderedFiles" :key="index" class="lite-file-card"
                            :class="{'is-selected': selectedFileSet.has(file)}" :data-file-index="index"
                            role="option" :aria-selected="selectedFileSet.has(file) ? 'true' : 'false'" tabindex="0"
                            @click="onRowClick(file, null, $event)" @dblclick.stop="onRowDbClick(file, null, $event)"
                            @contextmenu="onRowRightClick(file, null, $event)"
                            @keydown.enter.stop.prevent="onRowDbClick(file, null, $event)"
                            @keydown.space.stop.prevent="onGridCheckboxClick(file, $event)">
                            <input class="lite-file-card-checkbox" type="checkbox" :checked="selectedFileSet.has(file)"
                                :aria-label="file.name" @click.stop="onGridCheckboxClick(file, $event)" @dblclick.stop>
                            <img class="lite-file-grid-icon" :src="'/static/file/' + getNodeIcon(file) + '.svg'"
                                @error="onFileIconError" draggable="false" alt="">
                            <div class="lite-file-card-name" :title="file.name">{{ file.name }}</div>
                            <div class="lite-file-card-size">{{ formatBytes(file.size) }}</div>
                        </div>
                    </div>
                    <div v-if="gridSelectionBox" class="lite-file-selection-box" :style="gridSelectionBox"></div>
                </div>
            </div>
            <!-- 数据详情 -->
            <div class="data-details">
                <div class="data-details-count">{{ multipleSelection.length }} / {{ curResult.length }} {{ $t('language.common.itemsSelected') }}</div>
                <div class="data-details-size">{{ formatBytes(selectFileSize()) }} / {{ formatBytes(totalFileSize()) }}</div>
                <!-- 上传列表图标 -->
                <div class="upload-list-icon" v-if="uploadFiles.length>0" @click="showUploadList=!showUploadList"></div>
                <!-- 上传列表 -->
                <div class="upload-list-box" :style="{height:showUploadList?'245px':'0px'}">
                    <!-- 标题栏 -->
                    <div class="upload-list-title">
                        <!-- 标题 -->
                        <span>{{ $t('language.popup.progressBox') }} {{ uploadedCount }} / {{ uploadFiles.length }}</span>
                        <!-- 关闭图标 -->
                        <div class="upload-list-close" @click="showUploadList=false"></div>
                    </div>
                    <!-- 上传列表项列表 -->
                    <div class="upload-list-items myscroll" ref="uploadList">
                        <!-- 上传列表项 -->
                        <div class="upload-list-item" v-for="(file, index) in uploadFiles">
                            <!-- 文件名 -->
                            <div class="upload-list-name">{{ file.name }}</div>
                            <!-- 文件大小 -->
                            <div class="upload-list-size">{{ formatBytes(file.size) }}</div>
                            <!-- 等待 -->
                            <i v-if="file.status==undefined" class="el-icon-top" style="color:#909399;"></i>
                            <!-- 取消 -->
                            <i v-if="file.status==undefined" class="el-icon-circle-close" style="color:#909399;" @click="cancelUpload(index)"></i>
                            <!-- 准备中 -->
                            <i v-if="file.status=='loading' && !uploading.readDone" class="el-icon-loading" style="color:#5562B4;" :title="'Ready: ' + uploading.status"></i>
                            <!-- 上传中 -->
                            <el-progress v-if="file.status=='loading' && uploading.readDone" type="circle" :percentage="parseInt(uploading.status)" :show-text="false" :width="20" :stroke-width="2" color="#5562B4" :title="'Uploading: ' + uploading.status"></el-progress>
                            <!-- 成功 -->
                            <i v-if="file.status=='success'" class="el-icon-success" style="color:#67C23A;"></i>
                            <!-- 失败 -->
                            <i v-if="file.status=='error'" class="el-icon-warning" style="color:#F56C6C;" :data-msg="file.msg" :title="$t('language.cloudExploer.notUpload')"></i>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 加载中 -->
            <div class="lite-file-loading" v-show="fullscreenLoading"></div>
            <!-- 创建文件夹、重命名 -->
            <liteInput ref="inputPopup" :data="input_popup_data" @ok="inputPopupOK" />
            <!-- 确认弹窗检测 -->
            <liteConfirmCheck ref="confirmCheckPopup" :data="confirm_check_popup_data" @ok="confirmCheckPopupOK" />
            <!-- 确认弹窗 -->
            <liteConfirm ref="confirmPopup" :data="confirm_popup_data" @ok="confirmPopupOK" />
            <!-- 预览弹窗 -->
            <litePreview ref="previewPopup" :files="curResult" />
            <!-- 任务目标 -->
            <liteSelect ref="taskToTree" :showCheckbox="false" :showDBDrive="false" :showEmailDrive="false" :showFileNode="false" :showNewFolder="true" @selectDone="selectDoneTo" />
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { Message } from "element-ui";
import commonstate from '@/js/constant.js';
import requestUtils from '@/js/request_util.js';
import commonUtils from "@/js/workspace/common_util.js";
import liteInput from '@/components/workspace/lite_input.vue';
import liteConfirmCheck from '@/components/workspace/lite_confirm_check.vue';
import liteConfirm from '@/components/workspace/lite_confirm.vue';
import litePreview from '@/components/workspace/lite_preview.vue';
import liteSelect from "@/components/workspace/lite_select";
import taskListUtils from "@/js/workspace/task_list_util.js";

// 下个版本开放时只需将对应开关改为 true。
const LITE_FILE_FEATURES = {
    gridView: true,
    dragUpload: true,
};

export default {
    name: "liteFile",
    components: {
        liteInput,
        liteConfirm,
        liteConfirmCheck,
        litePreview,
        liteSelect,
    },
    data() {
        return {
            gridViewEnabled: LITE_FILE_FEATURES.gridView,
            dragUploadEnabled: LITE_FILE_FEATURES.dragUpload,
            isCtrlPressed: false,
            isShiftPressed: false,
            // 是否显示右键菜单
            showRightMenu: false,
            rightMenuX: 0,
            rightMenuY: 0,
            // 云盘页面当前选择的云盘
            curCloudId: '',
            // 是否在上传文件
            isUploading: false,
            isUploadDragOver: false,
            // 用户选择的文件
            uploadFiles: [],
            // 是否显示上传列表
            showUploadList: false,
            // 上传的目的地云盘和文件夹
            uploadParam: {
                did: '',
                node: null,
            },
            // 已上传个数进度
            uploadedCount: 0,
            // 正在上传的文件
            uploading: {
                uuid: '',
                status: '',
                readDone: false,
            },
            // 全屏加载
            fullscreenLoading: false,
            multipleSelection: [],
            fileView: 'list',
            fileSort: { prop: '', order: null },
            selectionAnchor: null,
            gridSelectionBox: null,
            // 当前节点的结果集
            curResult: [],
            // 当前节点的结果集的驱动器ID
            curResultDriveId: "",
            // 目录缓存是独立的扁平表；Node 只保留向上的 parent 引用，不维护 children。
            folderCache: new Map(),
            // 要复制的节点
            copyNodes: [],
            copyDid: null,
            copyWay: 'copy',
            // 创建任务参数
            taskParam: {
                type: "",
                name: "",
                fdid: "",
                tdid: "",
                param: {
                    from: null,
                    to: null,
                    options: {
                        listThread: commonUtils.getUser().vip ? 3 : 1,
                        runThread: commonUtils.getUser().vip ? 10 : 2,
                        email: '',
                        cron: '',
                        sameName: 'skip',
                        excludeNames: [],
                        allowedExtensions: [],
                        type: '',
                        onlyAdd: false,
                        schedules: {disabled:true},
                        delete: false,
                        keepDate: false,
                        logFile: false,
                        inOneFolder: true,
                        syncMode: '',
                    },
                },
            },
            // 输入框弹窗
            input_popup_data: {
                type: '',
                title: '',
                value: '',
                placeholder: '',
            },
            // 确认弹窗检测
            confirm_check_popup_data: {
                type: '',
                title: '',
                desc1: '',
                desc2: '',
                desc3: '',
                name: '',
                nameCheck: '',
            },
            // 确认弹窗
            confirm_popup_data: {
                type: '',
                title: '',
                desc: '',
            },
            // 目录请求序列号
            expandRandom: 0,
            // 创建任务中
            createTasking: false,
        }
    },
    watch: {
        curResult() {
            this.cancelGridSelection();
            // 列表局部更新（如逐项删除）时，仅移除已经不在列表中的选择，
            // 保留其余待处理项的选择状态；切换目录时节点对象会整体替换，选择会自然清空。
            const currentFiles = new Set(this.curResult);
            const retainedSelection = this.multipleSelection.filter(file => currentFiles.has(file));
            const selectionChanged = retainedSelection.length !== this.multipleSelection.length;
            if (!currentFiles.has(this.selectionAnchor)) {
                this.selectionAnchor = retainedSelection[0] || null;
            }
            this.setFileSelection(retainedSelection);
            // Element Table 在数据项删除后的渲染阶段会清空内部 selection，
            // 所以待渲染结束后再同步一次，避免该内部事件覆盖保留的选择。
            if (selectionChanged && this.fileView === 'list') {
                this.$nextTick(() => {
                    this.setFileSelection(retainedSelection.filter(file => this.curResult.includes(file)));
                });
            }
        },
        '$store.state.curDriveId'() {
            this.resetUploadDrag();
            this.cancelGridSelection();
            this.selectionAnchor = null;
            this.setFileSelection([]);
        },
        // 没有云盘跳转到添加云盘页面
        '$route.path': function (newValue) {
            this.resetUploadDrag();
            this.cancelGridSelection();
            if (newValue == "/mc_project/lite_file") {
                if (this.$store.state.drives.length == 0) {
                    this.addCloud();
                }
            }
        },
        '$store.state.needLoad': function (newValue) {
            if (newValue) {
                // 侧边栏切换云盘时允许命中根目录缓存；其他调用方仍表示强制重新加载。
                const useCache = !!(newValue && newValue.useCache);
                if (!useCache) {
                    this.curResult = [];
                }
                this.$store.state.needLoad = "";
                this.openFolder(
                    this.$store.state.curDriveId,
                    this.$store.state.curNode,
                    null,
                    !useCache
                );
            }
        },
        '$store.state.needLoadDriveInfo': function (newValue) {
            if (newValue) {
                this.$store.state.needLoadDriveInfo = false;
                this.loadAllDriveInfo();
            }
        },
    },
    computed: {
        selectedFileSet() {
            return new Set(this.multipleSelection);
        },
        orderedFiles() {
            const { prop, order } = this.fileSort;
            if (!prop || !order) return this.curResult;
            const value = file => {
                if (prop === 'name') return file.name == null ? '' : String(file.name).toLowerCase();
                if (prop === 'time') return file.time == null ? -1 : new Date(file.time).getTime();
                return file.size == null ? -1 : file.size;
            };
            return this.curResult.slice().sort((a, b) => {
                // 文件夹分组不受升降序影响，始终显示在普通文件之前。
                if (!!a.dir !== !!b.dir) return a.dir ? -1 : 1;
                const left = value(a);
                const right = value(b);
                const result = left < right ? -1 : left > right ? 1 : 0;
                return order === 'descending' ? -result : result;
            });
        },
        spaceDrives() {
            let drives = [];
            this.$store.state.drives.forEach(drive => {
                if (['GoogleDrive','OneDrive','Dropbox','Box','PCloud','MediaFire','ICloudPhotos','ICloudDrive','MEGA','OneDriveBusiness','DropboxBusiness','BoxBusiness','PutIO','FourShared','BaiDu','SugarSync','Egnyte'].includes(drive.type)) {
                    drives.push(drive);
                }
            });
            return drives;
        },
        noSpaceDrives() {
            let drives = [];
            this.$store.state.drives.forEach(drive => {
                if (['FTP','SFTP','WebDAV','MySQL','Backblaze','GoogleWorkspace','Website','GooglePhotos','AmazonS3','Wasabi','SharePoint','Flickr','Evernote','Gmail','Outlook','HiDrive','Yandex','NAS','IceDrive','OwnCloud','IDriveE2','ADrive','WEBDE','CloudMe','MyDrive'].includes(drive.type)) {
                    drives.push(drive);
                }
            });
            return drives;
        },
        countFTP() {
            let count = 0;
            this.$store.state.drives.forEach(drive => {
                if (['FTP','SFTP'].includes(drive.type)) {
                    count++;
                }
            });
            return count;
        },
        countWebDAV() {
            let count = 0;
            this.$store.state.drives.forEach(drive => {
                if (['WebDAV'].includes(drive.type)) {
                    count++;
                }
            });
            return count;
        },
        countDB() {
            let count = 0;
            this.$store.state.drives.forEach(drive => {
                if (['MySQL'].includes(drive.type)) {
                    count++;
                }
            });
            return count;
        },
    },
    mounted() {
        try {
            this.fileView = this.gridViewEnabled && localStorage.getItem('liteFileView') === 'grid' ? 'grid' : 'list';
        } catch (e) { /* 浏览器禁用存储时使用默认视图。 */ }
        if (this.$route.path=='/mc_project/lite_file') {
            this.$store.state.isLiteMode = true;
        }
        if (this.$store.state.curDriveId) {
            this.$store.state.needLoad = "";
            this.refresh();
        }
        this.uploadTimer = setInterval(() => {
            if (this.isUploading && this.uploading.readDone && this.uploading.uuid) {
                this.uploadProg(this.uploading.uuid, (data) => {
                    if (data && data.sum) {
                        const progress = (data.cur / data.sum) * 100;
                        const percent = progress.toFixed(2);
                        this.uploading.status = `${percent}%`;
                    }
                });
            }
        }, 3000);
        setTimeout(() => {
            this.loadAllDriveInfo();
        }, 500);
        document.addEventListener('click', this.hideRightMenu)
        window.addEventListener('keydown', this.onKeyDown)
        window.addEventListener('keyup', this.onKeyUp)
        window.addEventListener('blur', this.onFileWindowBlur)
        // 在文件区外松手时阻止浏览器直接打开本地文件，仅当前文件管理页生效。
        document.addEventListener('dragover', this.guardExternalFileDrop, true);
        document.addEventListener('drop', this.guardExternalFileDrop, true);
        document.addEventListener('dragend', this.resetUploadDrag);
        // 没有云盘跳转到添加云盘页面
        if (this.$store.state.drives.length == 0) {
            this.addCloud();
        }
    },
    beforeDestroy() {
        this.cancelGridSelection();
        if (this.uploadTimer) {
            clearInterval(this.uploadTimer);
            this.uploadTimer = null;
        }
        document.removeEventListener('click', this.hideRightMenu)
        window.removeEventListener('keydown', this.onKeyDown)
        window.removeEventListener('keyup', this.onKeyUp)
        window.removeEventListener('blur', this.onFileWindowBlur)
        document.removeEventListener('dragover', this.guardExternalFileDrop, true);
        document.removeEventListener('drop', this.guardExternalFileDrop, true);
        document.removeEventListener('dragend', this.resetUploadDrag);
    },
    methods: {
        toggleFileView() {
            if (!this.gridViewEnabled) {
                this.fileView = 'list';
                return;
            }
            this.cancelGridSelection();
            this.hideRightMenu();
            this.fileView = this.fileView === 'list' ? 'grid' : 'list';
            try {
                localStorage.setItem('liteFileView', this.fileView);
            } catch (e) { /* 视图切换不依赖本地存储。 */ }
            this.$nextTick(() => {
                if (this.fileView === 'list' && this.$refs.filesTable) {
                    this.syncTableSelection();
                    this.$refs.filesTable.doLayout();
                }
            });
        },
        onFileSortChange({ prop, order }) {
            this.cancelGridSelection();
            this.fileSort = { prop: prop || '', order };
        },
        sortGridFiles(prop, order = 'ascending') {
            if (!this.$refs.filesTable) return;
            if (prop) this.$refs.filesTable.sort(prop, order);
            else {
                this.$refs.filesTable.clearSort();
                this.onFileSortChange({ prop: '', order: null });
            }
        },
        setFileSelection(files) {
            const wanted = new Set(files);
            const next = this.orderedFiles.filter(file => wanted.has(file));
            if (next.length === this.multipleSelection.length && next.every((file, i) => file === this.multipleSelection[i])) return;
            this.multipleSelection = next;
            if (this.fileView === 'list') this.syncTableSelection();
            this.hideRightMenu();
        },
        syncTableSelection() {
            const table = this.$refs.filesTable;
            if (!table) return;
            // 批量同步时忽略中间 selection-change，避免选择状态被半成品覆盖。
            this._syncingFileSelection = true;
            try {
                const wanted = new Set(this.multipleSelection);
                const current = (table.selection || []).slice();
                const selected = new Set(current);
                current.forEach(file => {
                    if (!wanted.has(file)) table.toggleRowSelection(file, false);
                });
                this.multipleSelection.forEach(file => {
                    if (!selected.has(file)) table.toggleRowSelection(file, true);
                });
            } finally {
                this._syncingFileSelection = false;
            }
        },
        onTableSelect(selection, row) {
            this.selectionAnchor = row;
        },
        onFileNameClick(file, event) {
            if (event.ctrlKey || event.metaKey || event.shiftKey) this.onRowClick(file, null, event);
            else this.onRowDbClick(file, null, event);
        },
        onGridCheckboxClick(file, event) {
            this.onRowClick(file, null, {
                ctrlKey: true,
                shiftKey: event.shiftKey,
                preventDefault() {},
                stopPropagation() {},
            });
        },
        onGridKeyDown(event) {
            if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a') {
                event.preventDefault();
                this.setFileSelection(this.orderedFiles);
            } else if (event.key === 'Escape') {
                this.cancelGridSelection();
                this.setFileSelection([]);
                this.selectionAnchor = null;
            }
        },
        onFileIconError(event) {
            // 未知扩展名回退一次，默认图标缺失时不重复请求。
            if (!event.target.src.endsWith('/static/file/file.svg')) event.target.src = '/static/file/file.svg';
        },
        onFileWindowBlur() {
            this.resetUploadDrag();
            this.isCtrlPressed = false;
            this.isShiftPressed = false;
            this.cancelGridSelection();
        },
        startGridSelection(event) {
            if (event.button !== 0 || this.fullscreenLoading || event.target.closest('.lite-file-card')) return;
            const grid = this.$refs.fileGrid;
            const rect = grid.getBoundingClientRect();
            // 原生滚动条仍保留拖动行为。
            if (event.clientX >= rect.left + grid.clientWidth || event.clientY >= rect.top + grid.clientHeight) return;
            event.preventDefault();
            this.cancelGridSelection();
            this.hideRightMenu();
            grid.focus({ preventScroll: true });
            this._gridDrag = {
                startX: event.clientX - rect.left + grid.scrollLeft,
                startY: event.clientY - rect.top + grid.scrollTop,
                clientX: event.clientX,
                clientY: event.clientY,
                originX: event.clientX,
                originY: event.clientY,
                additive: event.ctrlKey || event.metaKey || event.shiftKey,
                initial: this.multipleSelection.slice(),
                active: false,
                // 几何信息只在开始时读取，拖动中无需逐个测量 DOM。
                items: Array.from(grid.querySelectorAll('.lite-file-card')).map(card => {
                    const bounds = card.getBoundingClientRect();
                    return {
                        file: this.orderedFiles[Number(card.dataset.fileIndex)],
                        left: bounds.left - rect.left + grid.scrollLeft,
                        top: bounds.top - rect.top + grid.scrollTop,
                        right: bounds.right - rect.left + grid.scrollLeft,
                        bottom: bounds.bottom - rect.top + grid.scrollTop,
                    };
                }),
            };
            document.addEventListener('mousemove', this.moveGridSelection);
            document.addEventListener('mouseup', this.finishGridSelection);
            window.addEventListener('resize', this.cancelGridSelection);
        },
        moveGridSelection(event) {
            const drag = this._gridDrag;
            if (!drag) return;
            if (event.buttons === 0) {
                this.finishGridSelection();
                return;
            }
            drag.clientX = event.clientX;
            drag.clientY = event.clientY;
            if (!drag.active && Math.hypot(event.clientX - drag.originX, event.clientY - drag.originY) >= 4) {
                drag.active = true;
                this.updateGridSelection();
            }
            if (drag.active) event.preventDefault();
        },
        updateGridSelection(schedule = true) {
            const drag = this._gridDrag;
            const grid = this.$refs.fileGrid;
            if (!drag || !drag.active || !grid) return;
            const rect = grid.getBoundingClientRect();
            // 鼠标接近滚动区边缘时持续滚动，允许框选屏幕外文件。
            const edge = 32;
            const bottom = rect.top + grid.clientHeight;
            if (drag.clientY < rect.top + edge) grid.scrollTop -= Math.min(18, (rect.top + edge - drag.clientY) / 2);
            else if (drag.clientY > bottom - edge) grid.scrollTop += Math.min(18, (drag.clientY - bottom + edge) / 2);
            const x = Math.max(0, Math.min(grid.clientWidth, drag.clientX - rect.left)) + grid.scrollLeft;
            const y = Math.max(0, Math.min(grid.clientHeight, drag.clientY - rect.top)) + grid.scrollTop;
            const box = {
                left: Math.min(drag.startX, x), top: Math.min(drag.startY, y),
                right: Math.max(drag.startX, x), bottom: Math.max(drag.startY, y),
            };
            const boxKey = [box.left, box.top, box.right, box.bottom].join(':');
            if (drag.lastBox !== boxKey) {
                drag.lastBox = boxKey;
                this.gridSelectionBox = {
                    left: box.left + 'px', top: box.top + 'px',
                    width: (box.right - box.left) + 'px', height: (box.bottom - box.top) + 'px',
                };
                const hits = drag.items.filter(item => item.left < box.right && item.right > box.left && item.top < box.bottom && item.bottom > box.top).map(item => item.file);
                this.setFileSelection(drag.additive ? drag.initial.concat(hits) : hits);
            }
            if (schedule) this._gridDragFrame = requestAnimationFrame(() => this.updateGridSelection());
        },
        finishGridSelection(event) {
            const drag = this._gridDrag;
            if (drag && drag.active) {
                if (event) {
                    drag.clientX = event.clientX;
                    drag.clientY = event.clientY;
                }
                // mouseup 可能先于下一帧，提交最后一次移动的位置。
                this.updateGridSelection(false);
            }
            if (drag && !drag.active && !drag.additive) {
                this.setFileSelection([]);
                this.selectionAnchor = null;
            } else if (drag && drag.active) {
                this.selectionAnchor = this.multipleSelection[0] || null;
            }
            this.cancelGridSelection();
        },
        cancelGridSelection() {
            if (this._gridDragFrame) cancelAnimationFrame(this._gridDragFrame);
            this._gridDragFrame = null;
            this._gridDrag = null;
            this.gridSelectionBox = null;
            document.removeEventListener('mousemove', this.moveGridSelection);
            document.removeEventListener('mouseup', this.finishGridSelection);
            window.removeEventListener('resize', this.cancelGridSelection);
        },
        hideRightMenu() {
            this.showRightMenu = false
        },
        onKeyDown(e) {
            if (e.key === 'Shift') {
                this.isShiftPressed = true
            }
            if (e.key === 'Control') {
                this.isCtrlPressed = true
            }
        },
        onKeyUp(e) {
            if (e.key === 'Shift') {
                this.isShiftPressed = false
            }
            if (e.key === 'Control') {
                this.isCtrlPressed = false
            }
        },
        // 勾选行样式名称
        liteFileCellClass({row, column, rowIndex, columnIndex}) {
            if (this.selectedFileSet.has(row)) {
                return 'lite-table-row-select';
            }
        },
        // 处理显示右键
        dealShowRightMenu(event) {
            this.showRightMenu = true
            this.$nextTick(() => {
                const menu = this.$refs.rightMenu
                if (!menu) return
                const menuWidth = menu.offsetWidth
                const menuHeight = menu.offsetHeight
                const winWidth = window.innerWidth
                const winHeight = window.innerHeight
                let x = event.clientX
                let y = event.clientY
                if (x + menuWidth > winWidth) {
                    x = winWidth - menuWidth - menuWidth + (x + menuWidth - winWidth)
                }
                if (y + menuHeight > winHeight) {
                    y = winHeight - menuHeight - menuHeight + (y + menuHeight - winHeight)
                }
                this.rightMenuX = Math.max(0, x)
                this.rightMenuY = Math.max(0, y)
            });
        },
        // 表格右击
        onTableRightClick(event) {
            this.dealShowRightMenu(event);
        },
        // 表格行右击
        onRowRightClick(row, column, event) {
            event.preventDefault();
            event.stopPropagation();
            if (!this.selectedFileSet.has(row)) {
                this.setFileSelection([row]);
                this.selectionAnchor = row;
            }
            this.dealShowRightMenu(event);
        },
        // 表格行双击
        onRowDbClick(row, column, event) {
            if (row.dir) {
                this.openFolder(this.$store.state.curDriveId, row, null);
            } else {
                this.previewFile(row);
            }
        },
        // 表格行单击
        onRowClick(row, column, event) {
            event.preventDefault();
            event.stopPropagation();
            const additive = event.ctrlKey || event.metaKey;
            const anchorIndex = this.orderedFiles.indexOf(this.selectionAnchor);
            const rowIndex = this.orderedFiles.indexOf(row);
            if (event.shiftKey && anchorIndex >= 0 && rowIndex >= 0) {
                const range = this.orderedFiles.slice(Math.min(anchorIndex, rowIndex), Math.max(anchorIndex, rowIndex) + 1);
                this.setFileSelection(additive ? this.multipleSelection.concat(range) : range);
            } else {
                this.setFileSelection(additive
                    ? (this.selectedFileSet.has(row) ? this.multipleSelection.filter(file => file !== row) : this.multipleSelection.concat(row))
                    : [row]);
                this.selectionAnchor = row;
            }
            this.showRightMenu = false;
        },
        selectAll() {
            this.setFileSelection(this.multipleSelection.length === this.curResult.length ? [] : this.orderedFiles);
            this.selectionAnchor = this.multipleSelection[0] || null;
        },
        addCloud() {
            this.$store.commit('setleftbannerMenuClick', 901);
            this.$router.push({ path: '/mc_project/add_cloud' });
        },
        // 获取文件上传进度
        uploadProg(uuid, callback) {
            this.sendRequest("/file/uploadProg", { uuid: uuid }, (data) => {
                callback(data);
            });
        },
        // 加载所有云盘信息
        async loadAllDriveInfo() {
            var drives = this.$store.state.drives;
            for (var i = 0; i < drives.length; i++) {
                await this.loadDriveInfo(drives[i]);
            }
        },
        // 加载云盘信息
        loadDriveInfo(drive) {
            return new Promise((resolve, reject) => {
                Vue.set(drive, 'loadDriveInfo', true);
                this.sendRequest("/drive/info", { id: drive.id }, (data) => {
                    Vue.set(drive, 'driveInfo', data);
                    Vue.set(drive, 'loadDriveInfo', false);
                    resolve();
                }, (res) => {
                    Vue.set(drive, 'errorMsg', res.msg);
                    Vue.set(drive, 'driveInfo', 'error');
                    Vue.set(drive, 'loadDriveInfo', false);
                    resolve();
                });
            });
        },
        // 获取云盘空间进度
        getDriveSpace(drive) {
            if (drive.driveInfo && drive.driveInfo != "error") {
                if (drive.driveInfo.total) {
                    return Math.floor(drive.driveInfo.used / drive.driveInfo.total * 100) + "%";
                } else {
                    return "0%";
                }
            } else {
                return "0%";
            }
        },
        // 获取云盘空间进度颜色
        getDriveSpaceColor(drive) {
            if (drive.driveInfo && drive.driveInfo != "error") {
                if (drive.driveInfo.total) {
                    const percent = Math.floor(drive.driveInfo.used / drive.driveInfo.total * 100);
                    return percent > 80 ? "#dc1f06" : "#5166bd";
                } else {
                    return "#5166bd";
                }
            } else {
                return "#5166bd";
            }
        },
        // 获取云盘空间信息
        getDriveInfo(drive) {
            if (drive.driveInfo && drive.driveInfo != "error") {
                if (drive.driveInfo.total) {
                    return this.formatBytes(drive.driveInfo.used) + "/" + this.formatBytes(drive.driveInfo.total);
                } else if (drive.driveInfo.used) {
                    return this.formatBytes(drive.driveInfo.used);
                } else {
                    return "No stored info";
                }
            } else {
                return drive.loadDriveInfo ? this.$t('language.common.load') : (drive.driveInfo == "error" ? this.$t('language.common.failure') : this.$t('language.common.waiting'));
            }
        },
        // 展开云盘根目录
        openDrive(id) {
            this.$store.state.curDriveId = id;
            this.$store.state.curNode = null;
            this.$store.state.curStart = null;
            this.openFolder(id, null, null);
        },
        // 显示所有云盘
        showDrives() {
            this.$store.state.curDriveId = "";
        },
        // 选择任务目标
        selectTaskTo(type) {
            this.taskParam.type = type;
            this.$refs.taskToTree.show = true;
        },
        // 任务目标选择完成
        selectDoneTo(data) {
            if (data.did) {
                this.taskParam.param.froms = null;
                this.taskParam.fdid = this.$store.state.curDriveId;
                this.taskParam.tdid = data.did;
                const froms = [];
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    const selectNode = this.multipleSelection[i];
                    froms.push({did:this.taskParam.fdid,node:selectNode});
                }
                const isMult = this.multipleSelection.length > 1;
                var fromNode = isMult ? this.multipleSelection[0].parent : this.multipleSelection[0];
                var toNode = data.node;
                var type = this.taskParam.type;
                var fromName = this.getTaskNameSub(fromNode, this.taskParam.fdid);
                var toName = this.getTaskNameSub(toNode, this.taskParam.tdid);
                if (type == 'tran') {
                    this.$store.state.liteFileTaskCountTran++;
                    this.taskParam.name = 'Transfer ' + fromName + ' to ' + toName;
                    if (isMult) {
                        this.taskParam.name = 'Transfer ' + fromName + ' ' + froms.length + ' items to ' + toName;
                        this.taskParam.param.froms = froms;
                    }
                } else if (type == 'sync') {
                    this.$store.state.liteFileTaskCountSync++;
                    this.taskParam.name = 'Synchronize ' + fromName + ' with ' + toName;
                } else if (type == 'backup') {
                    this.$store.state.liteFileTaskCountBackup++;
                    this.taskParam.name = 'Back up ' + fromName + ' to ' + toName;
                } else {
                    Message.warning('Task type error');
                }
                this.taskParam.param.from = fromNode;
                this.taskParam.param.to = toNode;
                this.createTask();
            } else {
                Message.warning("Please select a target directory");
            }
        },
        // 获取任务名称组成部分
        getTaskNameSub(node, did) {
            if (node) {
                var name = node.name;
                if (name.length > 100) {
                    return name.substring(0, 40) + '...' + name.substring(node.name.length - 40);
                } else {
                    return name;
                }
            } else {
                return this.getDrive(did).name;
            }
        },
        // 触发选择文件
        triggerUpload() {
            if (this.isFileUploadAllowed() && this.$refs.fileInput) this.$refs.fileInput.click();
        },
        isExternalFileDrag(event) {
            const transfer = event.dataTransfer;
            return !!transfer && (Array.from(transfer.types || []).includes('Files') ||
                Array.from(transfer.items || []).some(item => item.kind === 'file') ||
                (transfer.files && transfer.files.length > 0));
        },
        isFileUploadAllowed() {
            return !this.fullscreenLoading && this.showUpload();
        },
        canAcceptUploadDrop() {
            const target = this.uploadParam;
            return this.dragUploadEnabled && this.isFileUploadAllowed() && ((!target.did && target.node == null) ||
                (target.did === this.$store.state.curDriveId && target.node === this.$store.state.curNode));
        },
        isUploadDropTarget(event) {
            const zone = this.$refs.fileDropZone;
            return !!zone && zone.contains(event.target) &&
                !(event.target.closest && event.target.closest('.lite_popup, .popup, .right-menus, .upload-list-box'));
        },
        resetUploadDrag() {
            this.isUploadDragOver = false;
        },
        guardExternalFileDrop(event) {
            if (this.$route.path !== '/mc_project/lite_file' || !this.isExternalFileDrag(event)) return;
            event.preventDefault();
            if (!this.isUploadDropTarget(event)) {
                if (event.dataTransfer) event.dataTransfer.dropEffect = 'none';
                this.resetUploadDrag();
            }
            if (event.type === 'drop') this.resetUploadDrag();
        },
        onUploadDragEnter(event) {
            this.onUploadDragOver(event);
        },
        onUploadDragOver(event) {
            if (!this.isExternalFileDrag(event)) return;
            event.preventDefault();
            event.stopPropagation();
            if (!this.dragUploadEnabled) {
                this.resetUploadDrag();
                event.dataTransfer.dropEffect = 'none';
                return;
            }
            const inZone = this.isUploadDropTarget(event);
            this.isUploadDragOver = inZone;
            event.dataTransfer.dropEffect = inZone && this.canAcceptUploadDrop() ? 'copy' : 'none';
        },
        onUploadDragLeave(event) {
            // 在卡片、图标等子节点之间移动不应让提示闪烁。
            const zone = this.$refs.fileDropZone;
            if (!zone || !event.relatedTarget || !zone.contains(event.relatedTarget)) this.resetUploadDrag();
        },
        // 外部文件拖到当前目录后，复用文件选择器的上传队列。
        onDrop(e) {
            this.resetUploadDrag();
            if (!this.isExternalFileDrag(e)) return;
            e.preventDefault();
            e.stopPropagation();
            if (!this.dragUploadEnabled) return;
            if (!this.isUploadDropTarget(e)) return;
            if (!this.canAcceptUploadDrop()) {
                Message.warning(this.$t('language.common.uploadUnavailable'));
                return;
            }
            const transfer = e.dataTransfer;
            const items = Array.from(transfer.items || []).filter(item => item.kind === 'file');
            let hasDirectories = false;
            const files = items.length ? items.map(item => {
                const getEntry = item.getAsEntry || item.webkitGetAsEntry;
                const entry = getEntry ? getEntry.call(item) : null;
                if (entry && entry.isDirectory) {
                    hasDirectories = true;
                    return null;
                }
                return item.getAsFile();
            }).filter(Boolean) : Array.from(transfer.files || []);
            if (hasDirectories) Message.warning(this.$t('language.sharesPage.uploadFolder'));
            this.addUploadFiles(files);
        },
        // 选择上传
        handleFileChange(e) {
            this.addUploadFiles(e.target.files);
            e.target.value = ''
        },
        // 增加上传文件
        addUploadFiles(files) {
            // 文件选择器打开后目录或选择状态也可能改变，入队前必须重新校验。
            if (!this.isFileUploadAllowed()) return;
            if (files.length > 0 && this.canUpload()) {
                this.uploadFiles.push(...files);
                this.showUploadList = true;
                // 滚动到底部
                this.$nextTick(() => {
                    const el = this.$refs.uploadList
                    if (el) {
                        el.scrollTop = el.scrollHeight
                    }
                });
                if (!this.isUploading) {
                    this.startUpload();
                }
            }
        },
        // 取消上传
        cancelUpload(index) {
            this.uploadFiles.splice(index, 1);
        },
        // 是否可以上传
        canUpload() {
            if (this.uploadParam.did=='' && this.uploadParam.node==null) {
                // 首次上传
                this.uploadParam.did = this.$store.state.curDriveId;
                this.uploadParam.node = this.$store.state.curNode;
                return true;
            } else if (this.uploadParam.did==this.$store.state.curDriveId && this.uploadParam.node==this.$store.state.curNode) {
                // 相同目录上传
                return true;
            } else {
                // 其他目录上传
                Message.error('Files are being uploaded to other directories. Please try again later.');
                return false;
            }
        },
        // 上传文件
        async startUpload() {
            // 标记本次是否上传了文件
            let isUploaded = false;
            for (let i = 0; i < this.uploadFiles.length; i++) {
                const file = this.uploadFiles[i];
                if (file.status == undefined) {
                    file.status = "loading";
                    this.uploadedCount = i + 1;
                    this.uploading.status = "0%";
                    this.uploading.readDone = false;
                    this.isUploading = true;
                    try {
                        const uuid = await this.prepareUpload(file);
                        this.uploading.uuid = uuid;
                        const node = await this.uploadFile(uuid, file);
                        // 如果目录没有变化就追加上传的文件
                        if (this.uploadParam.did == this.$store.state.curDriveId && this.uploadParam.node == this.$store.state.curNode) {
                            this.curResult.push(node);
                        }
                        // 目标目录可能不是当前目录，不能继续使用它的旧缓存。
                        this.invalidateFolderCache(this.uploadParam.did, this.uploadParam.node);
                        file.status = "success";
                    } catch (err) {
                        file.status = "error";
                        file.msg = err;
                    }
                    // 滚动到当前文件
                    this.$nextTick(() => {
                        const el = this.$refs.uploadList
                        if (el) {
                            el.scrollTop = Math.max((i - 1) * 40, 0);
                        }
                    });
                    isUploaded = true;
                    break;
                }
            }
            if (isUploaded) {
                // 接着上传下一个文件
                this.startUpload();
            } else {
                this.isUploading = false;
                this.showUploadList = false;
                // 如果目录没有变化就刷新目录
                if (this.uploadParam.did == this.$store.state.curDriveId && this.uploadParam.node == this.$store.state.curNode) {
                    this.refresh();
                }
                // 重置参数
                this.uploadParam.did = '';
                this.uploadParam.node = null;
            }
        },
        // 上传文件新名称
        uploadNewName(name) {
            const existingNames = this.curResult.map(item => item.name)
            // 拆分文件名和扩展名
            const lastDotIndex = name.lastIndexOf('.')
            const baseName = lastDotIndex !== -1 ? name.slice(0, lastDotIndex) : name
            const ext = lastDotIndex !== -1 ? name.slice(lastDotIndex) : ''
            // 如果没有重复，直接返回
            if (!existingNames.includes(name)) {
                return name
            }
            // 从 1 开始递增查找
            let index = 1
            let newName
            do {
                newName = `${baseName}(${index})${ext}`
                index++
            } while (existingNames.includes(newName))
            return newName
        },
        // 准备上传
        prepareUpload(file) {
            return new Promise((resolve, reject) => {
                this.sendRequest("/file/upload", {
                        id: this.uploadParam.did,
                        param: {
                            node: this.uploadParam.node,
                            name: this.uploadNewName(file.name),
                            result: {
                                node: {
                                    type: "file",
                                    name: file.name,
                                    dir: false,
                                    size: file.size,
                                    time: file.lastModified
                                }
                            },
                        }
                    }, (data) => {
                        resolve(data);
                    }
                );
            });
        },
        // 开始上传
        uploadFile(uuid, file) {
            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append("uuid", uuid);
                formData.append("file", file);
                axios.post(commonstate.liteUrl + "/lite/file/uploadFile", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: progressEvent => {
                        if (progressEvent.total) {
                            const progress = (progressEvent.loaded / progressEvent.total) * 100;
                            const percent = progress.toFixed(2);
                            this.uploading.status = `${percent}%`;
                            this.uploading.readDone = progress>=100?true:false;
                            if (this.uploading.readDone) {
                                this.uploading.status = "0%";
                            }
                        }
                    }
                })
                .then(res => {
                    if (res.data.code === 200) {
                        Message.success("Upload success: " + res.data.data.name);
                        resolve(res.data.data);
                    } else {
                        Message.error(res.data.msg || "Upload failed");
                        reject(res.data.msg || "Upload failed");
                    }
                })
                .catch(err => {
                    reject(err);
                });
            });
        },
        sugarSyncCanWriteTo(node) {
            return !!node && [
                'sugarsync_root_folder',
                'sugarsync_shared_folder',
                'sugarsync_folder',
            ].includes(node.type);
        },
        sugarSyncCanModify(node) {
            return !!node && [
                'sugarsync_folder',
                'sugarsync_file',
            ].includes(node.type);
        },
        flickrCanUploadTo(node) {
            return !!node && [
                'flickr_all_photos',
                'flickr_album',
                'flickr_collection_album',
                'flickr_not_in_album',
            ].includes(node.type);
        },
        flickrCanMkdirIn(node) {
            return !!node && node.type == 'flickr_albums';
        },
        flickrCanModify(node) {
            return !!node && [
                'flickr_album',
                'flickr_owned_photo',
                'flickr_album_photo',
            ].includes(node.type);
        },
        evernoteCanUploadTo(node) {
            return !!node && node.type == 'evernote_attachments';
        },
        evernoteCanMkdirIn(node) {
            return !node || node.type == 'evernote_stack';
        },
        evernoteCanRename(node) {
            return !!node && [
                'evernote_notebook',
                'evernote_note',
            ].includes(node.type);
        },
        evernoteCanDelete(node) {
            return !!node && node.type == 'evernote_note';
        },
        gmailNodeRef(node) {
            if (!node || !node.id || node.id.indexOf('gmail:') != 0) {
                return {};
            }
            let value = node.id.substring('gmail:'.length).replace(/-/g, '+').replace(/_/g, '/');
            while (value.length % 4) {
                value += '=';
            }
            try {
                const binary = atob(value);
                const bytes = [];
                for (let i = 0; i < binary.length; i++) {
                    bytes.push('%' + ('00' + binary.charCodeAt(i).toString(16)).slice(-2));
                }
                return JSON.parse(decodeURIComponent(bytes.join('')));
            } catch (e) {
                return {};
            }
        },
        gmailCanUploadTo(node) {
            if (!node) {
                return false;
            }
            if (node.type == 'gmail_user_label') {
                return true;
            }
            if (node.type == 'gmail_system_label') {
                const ref = this.gmailNodeRef(node);
                return ['INBOX', 'DRAFT', 'ALL_MAIL'].includes(ref.labelId);
            }
            return false;
        },
        gmailCanMkdirIn(node) {
            return !!node && ['gmail_labels_root', 'gmail_user_label'].includes(node.type);
        },
        gmailCanRename(node) {
            return !!node && node.type == 'gmail_user_label';
        },
        gmailCanDelete(node) {
            return !!node && ['gmail_user_label', 'gmail_thread', 'gmail_message'].includes(node.type);
        },
        gmailCanPasteTo(node) {
            if (!this.gmailCanUploadTo(node)) {
                return false;
            }
            for (let i = 0; i < this.copyNodes.length; i++) {
                const copyNode = this.copyNodes[i];
                if (copyNode.dir || !copyNode.name || !copyNode.name.toLowerCase().endsWith('.eml')) {
                    return false;
                }
            }
            return true;
        },
        showUpload() {
            if (this.multipleSelection.length == 0 && this.$store.state.curDriveId != "") {
                const drive = this.getDrive(this.$store.state.curDriveId);
                const curNode = this.$store.state.curNode;
                const type = drive.type;
                if (type == "GoogleDrive") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id == "sharedWithMe" || curNode.id == "sharedDrives") {
                        return false;
                    }
                } else if (type == "GoogleWorkspace") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id.indexOf("customer_") == 0) {
                        return false;
                    } else if (curNode.id == "sharedWithMe" || curNode.id == "sharedDrives") {
                        return false;
                    }
                } else if (type == "Backblaze") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "Website") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "GooglePhotos") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id!='/photos' && !curNode.id.startsWith('/albums/')) {
                        return false;
                    }
                } else if (type == "ICloudPhotos") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id=='/photos') {
                        return true;
                    } else if (curNode.type=='album' && curNode.time!=null) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (type == "AmazonS3") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "Wasabi") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "DropboxBusiness") {
                    if (curNode == null || curNode.type == 'membersRoot' || curNode.type == 'teamFilesRoot' || curNode.type == 'SHARED_FOLDER') {
                        return false;
                    }
                } else if (type == "BoxBusiness") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "OneDriveBusiness") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "SharePoint") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.parent == null) {
                        return false;
                    }
                } else if (type == "SugarSync") {
                    if (!this.sugarSyncCanWriteTo(curNode)) {
                        return false;
                    }
                } else if (type == "Flickr") {
                    if (!this.flickrCanUploadTo(curNode)) {
                        return false;
                    }
                } else if (type == "Evernote") {
                    if (!this.evernoteCanUploadTo(curNode)) {
                        return false;
                    }
                } else if (type == "Gmail") {
                    if (!this.gmailCanUploadTo(curNode)) {
                        return false;
                    }
                } else if (type == "Outlook") {
                    if (!curNode || curNode.type != 'outlook_folder') {
                        return false;
                    }
                }
                return true;
            }
            return false;
        },
        // GooglePhotos创建会话选择照片
        triggerAddPhotos() {
            const id = this.$store.state.curDriveId;
            const node = this.$store.state.curNode;
            const name = 'Selected photos on ' + this.formatGooglePhotosSessionDate();
            this.mkdir(id, node, name);
        },
        triggerBucket() {
            this.input_popup_data.type = "mkdir";
            this.input_popup_data.title = this.$t('language.cloudExploer.newBucket');
            this.input_popup_data.value = "";
            this.input_popup_data.placeholder = this.$t('language.cloudExploer.pleaseEnterBucketName');
            this.$refs.inputPopup.show = true;
        },
        // 打开创建文件夹弹窗
        triggerMkdir() {
            this.input_popup_data.type = "mkdir";
            this.input_popup_data.title = this.$t('language.cloudExploer.newFolder');
            this.input_popup_data.value = "";
            this.input_popup_data.placeholder = this.$t('language.cloudExploer.pleaseEnterFolderName');
            this.$refs.inputPopup.show = true;
        },
        // 输入框弹窗确认
        inputPopupOK() {
            const type = this.input_popup_data.type;
            const name = this.input_popup_data.value;
            if (type === "mkdir") {
                const id = this.$store.state.curDriveId;
                const node = this.$store.state.curNode;
                this.mkdir(id, node, name);
            } else if (type === "rename") {
                const id = this.$store.state.curDriveId;
                const node = this.multipleSelection[0];
                if (name != node.name) {
                    this.rename(id, node, name);
                }
            }
        },
        // 是否显示GooglePhotos选择照片
        showAddPhotos() {
            if (this.multipleSelection.length == 0 && this.$store.state.curDriveId != "") {
                const drive = this.getDrive(this.$store.state.curDriveId);
                const curNode = this.$store.state.curNode;
                const type = drive.type;
                if (type == "GooglePhotos") {
                    if (curNode == null) {
                        return true;
                    }
                }
            }
            return false;
        },
        showBucket() {
            if (this.multipleSelection.length == 0 && this.$store.state.curDriveId != "") {
                const drive = this.getDrive(this.$store.state.curDriveId);
                const curNode = this.$store.state.curNode;
                const type = drive.type;
                if (type == "AmazonS3") {
                    if (curNode == null) {
                        return true;
                    }
                } else if (type == "Wasabi") {
                    if (curNode == null) {
                        return true;
                    }
                }
            }
            return false;
        },
        showMkdir() {
            if (this.multipleSelection.length == 0 && this.$store.state.curDriveId != "") {
                const drive = this.getDrive(this.$store.state.curDriveId);
                const curNode = this.$store.state.curNode;
                const type = drive.type;
                if (type == "GoogleDrive") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id == "sharedWithMe" || curNode.id == "sharedDrives") {
                        return false;
                    }
                } else if (type == "GoogleWorkspace") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id.indexOf("customer_") == 0) {
                        return false;
                    } else if (curNode.id == "sharedWithMe" || curNode.id == "sharedDrives") {
                        return false;
                    }
                } else if (type == "MySQL") {
                    return false;
                } else if (type == "Backblaze") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "Website") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id.indexOf("MySQL_") == 0) {
                        return false;
                    }
                } else if (type == "GooglePhotos") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id != '/albums') {
                        return false;
                    }
                } else if (type == "ICloudPhotos") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id == '/albums') {
                        return true;
                    } else if (curNode.type == 'folder') {
                        return true;
                    } else {
                        return false;
                    }
                } else if (type == "AmazonS3") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "Wasabi") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "DropboxBusiness") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.type == 'membersRoot' || curNode.type == 'teamFilesRoot' || curNode.type == 'SHARED_FOLDER') {
                        return false;
                    }
                } else if (type == "BoxBusiness") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "OneDriveBusiness") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "SharePoint") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.parent == null) {
                        return false;
                    }
                } else if (type == "SugarSync") {
                    if (!this.sugarSyncCanWriteTo(curNode)) {
                        return false;
                    }
                } else if (type == "Flickr") {
                    if (!this.flickrCanMkdirIn(curNode)) {
                        return false;
                    }
                } else if (type == "Evernote") {
                    if (!this.evernoteCanMkdirIn(curNode)) {
                        return false;
                    }
                } else if (type == "Gmail") {
                    if (!this.gmailCanMkdirIn(curNode)) {
                        return false;
                    }
                } else if (type == "Outlook") {
                    if (curNode && curNode.type != 'outlook_folder') {
                        return false;
                    }
                }
                return true;
            }
            return false;
        },
        // 下载文件
        async downLoadFile() {
            const node = this.multipleSelection[0];
            const uuid = await this.prepareDownload(node);
            location.href = `${commonstate.liteUrl}/lite/file/downloadFile?uuid=${uuid}`;
        },
        // 准备下载
        prepareDownload(node) {
            return new Promise((resolve, reject) => {
                this.sendRequest("/file/download", {
                        id: this.$store.state.curDriveId,
                        param: {
                            node: node,
                        }
                    }, (data) => {
                        resolve(data);
                    }
                );
            });
        },
        showDownload() {
            return this.multipleSelection.length == 1 && !this.multipleSelection[0].dir;
        },
        // 确认弹窗检测
        confirmCheckPopupOK() {
            this.confirm_popup_data.type = "delete";
            this.confirm_popup_data.title = this.$t('language.common.delete');
            this.confirm_popup_data.desc = this.$t('language.popup.cloudExploerPopup.deleteContent');
            this.$refs.confirmPopup.show = true;
        },
        // 确认弹窗
        async confirmPopupOK() {
            const type = this.confirm_popup_data.type;
            if (type == 'delete') {
                const id = this.$store.state.curDriveId;
                var nodes = [];
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    const node = this.multipleSelection[i];
                    nodes.push(node);
                }
                for (let i = 0; i < nodes.length; i++) {
                    const node = nodes[i];
                    await this.delete(id, node, (data) => {
                        const index = this.curResult.findIndex(item => item.id === data.id);
                        if (index !== -1) {
                            this.curResult.splice(index, 1);
                        }
                    });
                }
                this.cacheCurrentFolder();
            }
        },
        // 删除文件
        deleteFile() {
            const drive = this.getDrive(this.$store.state.curDriveId);
            if (drive.type == "MySQL") {
                this.confirm_check_popup_data.type = "delete";
                this.confirm_check_popup_data.title = this.$t('language.popup.cloudExploerPopup.deleteConfirm');
                this.confirm_check_popup_data.desc1 = this.$t('language.popup.cloudExploerPopup.deleteContent');
                this.confirm_check_popup_data.desc2 = this.$t('language.popup.cloudExploerPopup.deleteAction');
                this.confirm_check_popup_data.desc3 = this.$t('language.popup.cloudExploerPopup.deleteDeletion');
                this.confirm_check_popup_data.name = this.multipleSelection[0].name;
                this.confirm_check_popup_data.nameCheck = '';
                this.$refs.confirmCheckPopup.show = true;
            } else {
                this.confirm_popup_data.type = "delete";
                this.confirm_popup_data.title = this.$t('language.common.delete');
                this.confirm_popup_data.desc = this.$t('language.popup.cloudExploerPopup.deleteContent');
                this.$refs.confirmPopup.show = true;
            }
        },
        showDelete() {
            if (this.multipleSelection.length > 0) {
                const drive = this.getDrive(this.$store.state.curDriveId);
                const type = drive.type;
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    const node = this.multipleSelection[i];
                    const fileId = node.id;
                    if (type == "GoogleDrive") {
                        if (fileId == "root" || fileId == "sharedDrives" || fileId == "sharedWithMe") {
                            return false;
                        } else {
                            const parent = node.parent;
                            if (parent) {
                                const parentId = parent.id;
                                if(parentId == "sharedDrives" || parentId == "sharedWithMe") {
                                    return false;
                                }
                            }
                        }
                    } else if (type == "GoogleWorkspace") {
                        if (fileId.indexOf("customer_") == 0) {
                            return false;
                        } else if (fileId == "root" || fileId == "sharedDrives" || fileId == "sharedWithMe") {
                            return false;
                        } else {
                            const parent = node.parent;
                            if (parent) {
                                const parentId = parent.id;
                                if(parentId == "sharedDrives" || parentId == "sharedWithMe") {
                                    return false;
                                }
                            }
                        }
                    } else if (type == "MySQL" && this.multipleSelection.length > 1) {
                        return false;
                    } else if (type == "Backblaze") {
                        const parent = node.parent;
                        if (!parent) {
                            return false;
                        }
                    } else if (type == "Website") {
                        const parent = node.parent;
                        if (!parent) {
                            return false;
                        }
                    } else if (type == "GooglePhotos") {
                        let allIsSession = true;
                        for (let i = 0; i < this.multipleSelection.length; i++) {
                            const node = this.multipleSelection[i];
                            if (!node.id.startsWith('/session/')) {
                                allIsSession = false;
                                break;
                            }
                        }
                        return allIsSession;
                    } else if (type == "ICloudPhotos") {
                        if (node.parent == null) {
                            return false;
                        } else if (node.time == null) {
                            return false;
                        }
                    } else if (type == "DropboxBusiness") {
                        if (node.parent == null || node.parent.type == 'membersRoot' || node.parent.type == 'teamFilesRoot' || node.parent.type == 'SHARED_FOLDER') {
                            return false;
                        }
                    } else if (type == "BoxBusiness") {
                        if (node.parent == null) {
                            return false;
                        }
                    } else if (type == "OneDriveBusiness") {
                        if (node.parent == null) {
                            return false;
                        }
                    } else if (type == "SharePoint") {
                        if (node.parent == null) {
                            return false;
                        } else if (node.parent.parent == null) {
                            return false;
                        }
                    } else if (type == "SugarSync") {
                        if (!this.sugarSyncCanModify(node)) {
                            return false;
                        }
                    } else if (type == "Flickr") {
                        if (!this.flickrCanModify(node)) {
                            return false;
                        }
                    } else if (type == "Evernote") {
                        if (!this.evernoteCanDelete(node)) {
                            return false;
                        }
                    } else if (type == "Gmail") {
                        if (!this.gmailCanDelete(node)) {
                            return false;
                        }
                    } else if (type == "Outlook") {
                        if (!['outlook_folder', 'outlook_message'].includes(node.type)) {
                            return false;
                        }
                    }
                }
                return true;
            }
            return false;
        },
        renameFile() {
            this.input_popup_data.type = "rename";
            this.input_popup_data.title = this.$t('language.common.rename');
            this.input_popup_data.value = this.multipleSelection[0].name;
            this.input_popup_data.placeholder = this.$t('language.cloudExploer.pleaseInputNewName');
            this.$refs.inputPopup.show = true;
        },
        showRename() {
            if (this.multipleSelection.length == 1) {
                const drive = this.getDrive(this.$store.state.curDriveId);
                const node = this.multipleSelection[0];
                const fileId = node.id;
                const type = drive.type;
                if (type == "GoogleDrive") {
                    if (fileId == "root" || fileId == "sharedDrives" || fileId == "sharedWithMe") {
                        return false;
                    } else {
                        const parent = node.parent;
                        if (parent) {
                            const parentId = parent.id;
                            if(parentId == "sharedDrives" || parentId == "sharedWithMe") {
                                return false;
                            }
                        }
                    }
                } else if (type == "GoogleWorkspace") {
                    if (fileId.indexOf("customer_") == 0) {
                        return false;
                    } else if (fileId == "root" || fileId == "sharedDrives" || fileId == "sharedWithMe") {
                        return false;
                    } else {
                        const parent = node.parent;
                        if (parent) {
                            const parentId = parent.id;
                            if(parentId == "sharedDrives" || parentId == "sharedWithMe") {
                                return false;
                            }
                        }
                    }
                } else if (type == "MySQL") {
                    return false;
                } else if (type == "Backblaze") {
                    return false;
                } else if (type == "Website") {
                    const parent = node.parent;
                    if (!parent) {
                        return false;
                    } else if (fileId.indexOf("MySQL_") == 0) {
                        return false;
                    }
                } else if (type == "GooglePhotos") {
                    return false;
                } else if (type == "ICloudPhotos") {
                    if (node.parent == null) {
                        return false;
                    } else if (node.time == null) {
                        return false;
                    }
                } else if (type == "AmazonS3") {
                    if (node.parent == null) {
                        return false;
                    }
                } else if (type == "Wasabi") {
                    if (node.parent == null) {
                        return false;
                    }
                } else if (type == "DropboxBusiness") {
                    if (node.parent == null || node.parent.type == 'membersRoot' || node.parent.type == 'teamFilesRoot' || node.parent.type == 'SHARED_FOLDER') {
                        return false;
                    }
                } else if (type == "BoxBusiness") {
                    if (node.parent == null) {
                        return false;
                    }
                } else if (type == "OneDriveBusiness") {
                    if (node.parent == null) {
                        return false;
                    }
                } else if (type == "SharePoint") {
                    if (node.parent == null) {
                        return false;
                    } else if (node.parent.parent == null) {
                        return false;
                    }
                } else if (type == "SugarSync") {
                    if (!this.sugarSyncCanModify(node)) {
                        return false;
                    }
                } else if (type == "Flickr") {
                    if (!this.flickrCanModify(node)) {
                        return false;
                    }
                } else if (type == "Evernote") {
                    if (!this.evernoteCanRename(node)) {
                        return false;
                    }
                } else if (type == "Gmail") {
                    if (!this.gmailCanRename(node)) {
                        return false;
                    }
                } else if (type == "Outlook") {
                    if (node.type != 'outlook_folder') {
                        return false;
                    }
                }
                return true;
            }
            return false;
        },
        previewFile(node) {
            if (!node) {
                node = this.multipleSelection[0];
            }
            const index = this.curResult.findIndex(item => item.id === node.id);
            if (index !== -1) {
                this.$refs.previewPopup.show = true;
                this.$refs.previewPopup.currentIndex = index;
            }
        },
        showPreview() {
            return this.multipleSelection.length == 1;
        },
        copyFile() {
            const count = this.multipleSelection.length;
            if (count > 200) {
                Message.warning(this.$t('language.cloudExploer.simultaneous'));
                return;
            }
            this.copyNodes = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
                const node = this.multipleSelection[i];
                this.copyNodes.push(node);
            }
            this.copyDid = this.$store.state.curDriveId;
            this.copyWay = 'copy';
            Message.success(this.$t('language.cloudExploer.copiedToClipboard'));
        },
        showCopy() {
            return this.multipleSelection.length > 0;
        },
        showCut() {
            return this.showDelete();
        },
        cutFile() {
            this.copyFile();
            this.copyWay = 'cut';
        },
        async pasteFile() {
            if (this.copyNodes.length>0 && this.copyDid) {
                const tdid = this.$store.state.curDriveId;
                const toNode = this.$store.state.curNode;
                const froms = [];
                const isMult = this.copyNodes.length > 1;
                const sourceFolder = this.copyNodes[0].parent;
                for (let i = 0; i < this.copyNodes.length; i++) {
                    const copyNode = this.copyNodes[i];
                    froms.push({did:tdid,node:copyNode});
                }
                this.taskParam.type = "copy";
                this.taskParam.fdid = this.copyDid;
                this.taskParam.tdid = tdid;
                var isCut = this.copyWay == 'cut';
                var fromNode = isMult ? this.copyNodes[0].parent : this.copyNodes[0];
                var fromName = this.getTaskNameSub(fromNode, this.taskParam.fdid);
                var toName = this.getTaskNameSub(toNode, this.taskParam.tdid);
                this.taskParam.name = (isCut ? this.$t('language.common.cut') : this.$t('language.common.copy')) + ' ' + fromName + ' to ' + toName;
                if (isMult) {
                    this.taskParam.name = (isCut ? this.$t('language.common.cut') : this.$t('language.common.copy')) + ' ' + fromName + ' ' + this.copyNodes.length + ' items to ' + toName;
                    this.taskParam.param.froms = froms;
                }
                this.taskParam.param.options.delete = isCut;
                this.taskParam.param.from = fromNode;
                this.taskParam.param.to = toNode;
                await this.createTask(() => {
                    this.$store.state.liteFileTaskCountCopy++;
                });
                // 复制/剪切任务会异步修改目录，下一次进入相关目录时重新读取。
                this.invalidateFolderCache(tdid, toNode);
                if (isCut) {
                    this.invalidateFolderCache(this.copyDid, sourceFolder);
                }
                this.taskParam.param.options.delete = false;
                this.taskParam.param.froms = null;
                this.copyNodes = [];
                this.copyDid = null;
                Message.success("Task created successfully");
                this.listTasks();
            }
        },
        showPaste() {
            if (this.multipleSelection.length > 0) {
                return false;
            }
            if (this.copyNodes.length>0 && this.copyDid) {
                const drive = this.getDrive(this.$store.state.curDriveId);
                const curNode = this.$store.state.curNode;
                const type = drive.type;
                if (this.copyDid == this.$store.state.curDriveId) {
                    if (this.copyNodes[0].parent == curNode) {
                        return false;
                    }
                }
                if (type == "GoogleDrive") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id == "sharedWithMe" || curNode.id == "sharedDrives") {
                        return false;
                    }
                } else if (type == "GoogleWorkspace") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id.indexOf("customer_") == 0) {
                        return false;
                    } else if (curNode.id == "sharedWithMe" || curNode.id == "sharedDrives") {
                        return false;
                    }
                } else if (type == "MySQL") {
                    if (this.copyNodes.length!=1 || !this.copyNodes[0].name.endsWith(".sql")) {
                        return false;
                    }
                } else if (type == "Backblaze") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "Website") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id.indexOf("MySQL_") == 0) {
                        if (this.copyNodes.length!=1 || !this.copyNodes[0].name.endsWith(".sql")) {
                            return false;
                        }
                    }
                } else if (type == "ICloudPhotos") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.id=='/photos') {
                        return true;
                    } else if (curNode.type=='album' && curNode.time!=null) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (type == "DropboxBusiness") {
                    if (curNode == null || curNode.type == 'membersRoot' || curNode.type == 'teamFilesRoot' || curNode.type == 'SHARED_FOLDER') {
                        return false;
                    }
                } else if (type == "BoxBusiness") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "OneDriveBusiness") {
                    if (curNode == null) {
                        return false;
                    }
                } else if (type == "SharePoint") {
                    if (curNode == null) {
                        return false;
                    } else if (curNode.parent == null) {
                        return false;
                    }
                } else if (type == "SugarSync") {
                    if (!this.sugarSyncCanWriteTo(curNode)) {
                        return false;
                    }
                } else if (type == "Flickr") {
                    if (!this.flickrCanUploadTo(curNode)) {
                        return false;
                    }
                } else if (type == "Evernote") {
                    if (!this.evernoteCanUploadTo(curNode)) {
                        return false;
                    }
                } else if (type == "Gmail") {
                    if (!this.gmailCanPasteTo(curNode)) {
                        return false;
                    }
                } else if (type == "Outlook") {
                    if (!curNode || curNode.type != 'outlook_folder') {
                        return false;
                    }
                    for (let i = 0; i < this.copyNodes.length; i++) {
                        const copyNode = this.copyNodes[i];
                        if (copyNode.dir || !copyNode.name || !copyNode.name.toLowerCase().endsWith('.eml')) {
                            return false;
                        }
                    }
                }
                return true;
            }
            return false;
        },
        showTranTo() {
            if (this.multipleSelection.length >= 1) {
                const drive = this.getDrive(this.$store.state.curDriveId);
                const type = drive.type;
                if (type == "Website") {
                    return false;
                }
                return true;
            }
            return false;
        },
        showSyncWith() {
            // 暂时不显示
            return false;
            if (this.multipleSelection.length == 1 && this.multipleSelection[0].dir) {
                const drive = this.getDrive(this.$store.state.curDriveId);
                const type = drive.type;
                if (type == "Website") {
                    return false;
                }
                return true;
            }
            return false;
        },
        showBackupTo() {
            // 暂时不显示
            return false;
            if (this.multipleSelection.length == 1) {
                const drive = this.getDrive(this.$store.state.curDriveId);
                const type = drive.type;
                if (type == "Website") {
                    return false;
                }
                return true;
            }
            return false;
        },
        loadNext() {
            this.openFolder(this.$store.state.curDriveId, this.$store.state.curNode, this.$store.state.curStart);
        },
        showNext() {
            return this.$store.state.curStart;
        },
        // 选中文件大小
        selectFileSize() {
            var size = 0;
            for (var i = 0; i < this.multipleSelection.length; i++) {
                var temp = this.multipleSelection[i].size;
                if (temp && temp > 0) {
                    size += temp;
                }
            }
            return size;
        },
        // 总文件大小
        totalFileSize() {
            var size = 0;
            var files = this.curResult;
            for (var i = 0; i < files.length; i++) {
                var temp = files[i].size;
                if (temp && temp > 0) {
                    size += temp;
                }
            }
            return size;
        },
        // 获取文件图标
        getNodeIcon(node) {
            if (node.dir) {
                if (node.type == "site") {
                    // 站点
                    return "site";
                } else if (node.type == "db") {
                    // 数据库
                    return "db";
                } else {
                    // 文件夹或相簿
                    return "folder";
                }
            } else {
                const index = node.name.lastIndexOf(".");
                if (index == -1) {
                    // 没有后缀的文件
                    return "file";
                } else {
                    const suffix = node.name.substring(index + 1).toLowerCase();
                    if (suffix.length == 0) {
                        // 包含点，但是没有后缀
                        return "file";
                    } else {
                        // 返回文件后缀，不一定靠谱
                        return suffix;
                    }
                }
            }
        },
        // 选择的文件
        handleSelectionChange(val) {
            if (this._syncingFileSelection || this.fileView !== 'list') return;
            this.multipleSelection = val;
            this.showRightMenu = false;
        },
        // 创建任务
        createTask(callback) {
            if (this.createTasking) return;
            // 未设置任务名称
            if (!this.taskParam.name) {
                Message.error("Please input task name");
                return;
            }
            // 未选择源
            if (!this.taskParam.fdid) {
                Message.error("Please select source cloud");
                return;
            }
            // 未选择目标
            if (!this.taskParam.tdid) {
                Message.error("Please select destination cloud");
                return;
            }
            // 非传输、复制、备份任务源只能是文件夹
            let from = this.taskParam.param.from;
            if (from && !from.dir && this.taskParam.type != 'tran' && this.taskParam.type != 'copy' && this.taskParam.type != 'backup') {
                Message.error("The source of non-transfer tasks can only be a folder");
                return;
            }
            // 目标只能是文件夹
            let to = this.taskParam.param.to;
            if (to && !to.dir) {
                Message.error("Task targets can only be folders");
                return;
            }
            // 快捷创建任务：设置类型与任务类型匹配
            this.taskParam.param.options.type = this.taskParam.type;
            // 开始创建任务
            return new Promise((resolve, reject) => {
                this.createTasking = true;
                this.sendRequest("/task/create", this.taskParam, () => {
                    this.createTasking = false;
                    let that = this;
                    taskListUtils.exeSuccessEnd('liteFileElement', 'taskList', [], that);
                    if (callback) {
                        callback();
                    } else {
                        Message.success("Task created successfully");
                        this.listTasks();
                    }
                    resolve();
                });
            });
        },
        clearPageChoose() {
            // 有用，不能删除
        },
        // 格式化字节数
        formatBytes(value) {
            if (value === null || value === undefined) return '';
            if (value === 0) return '0Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
            const i = Math.floor(Math.log(value) / Math.log(k));
            const num = value / Math.pow(k, i);
            return Number.isInteger(num)
                ? num + sizes[i]
                : num.toFixed(2) + sizes[i];
        },
        // 格式化时间
        formatDate(value) {
            if (!value) return '';
            const date = new Date(value);
            return date.toLocaleString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }).replace(/,/g, '');
        },
        // 格式化GooglePhotos创建会话的时间
        formatGooglePhotosSessionDate() {
            const date = new Date();
            return date.toLocaleString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }).replace(/,/g, '').replace(/:/g, '_');
        },
        // 获取云盘
        getDrive(id) {
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                let drive = this.$store.state.drives[i];
                if (drive.id === id) {
                    return drive;
                }
            }
            return null;
        },
        // 获取节点路径
        getNodePath(node) {
            let path = '';
            let arr = this.getNodeArr(node);
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                path += '/' + item.name;
            }
            return path;
        },
        // 获取节点和父
        getNodeArr(node) {
            let arr = [];
            while (node) {
                arr.push(node);
                node = node.parent;
            }
            return arr.reverse();
        },
        getFolderCacheKey(id, node) {
            // 使用 JSON 编码避免 drive id、node id 中的字符造成键冲突。
            return JSON.stringify([id, node ? node.id : null]);
        },
        cloneNodeWithoutParent(node) {
            // 缓存快照不保留 parent，确保缓存中不存在父子双向引用或递归结构。
            const clonedNode = Object.assign({}, node);
            delete clonedNode.parent;
            return clonedNode;
        },
        restoreCachedNodes(nodes, parent) {
            // 每次展示缓存结果时才绑定当前父节点，供路径、选择和任务创建使用。
            return nodes.map(node => {
                const restoredNode = this.cloneNodeWithoutParent(node);
                restoredNode.parent = parent;
                return restoredNode;
            });
        },
        setFolderCache(id, node, nodes, next) {
            this.folderCache.set(this.getFolderCacheKey(id, node), {
                nodes: nodes.map(item => this.cloneNodeWithoutParent(item)),
                next: next,
            });
        },
        getFolderCache(id, node) {
            return this.folderCache.get(this.getFolderCacheKey(id, node));
        },
        invalidateFolderCache(id, node) {
            this.folderCache.delete(this.getFolderCacheKey(id, node));
        },
        cacheCurrentFolder() {
            const id = this.$store.state.curDriveId;
            if (!id) return;
            this.setFolderCache(id, this.$store.state.curNode, this.curResult, this.$store.state.curStart);
        },
        // 删除
        delete(id, node, callback) {
            return new Promise((resolve, reject) => {
                this.sendRequest("/file/delete", { id: id, param: { node: node } }, (data) => {
                    if (node.dir) {
                        this.invalidateFolderCache(id, node);
                    }
                    if (callback) callback(data);
                    resolve(data);
                });
            });
        },
        // 重命名
        rename(id, node, name) {
            this.sendRequest("/file/rename", { id: id, param: { node: node, name: name } }, (data) => {
                this.refresh();
            });
        },
        // 创建文件夹
        mkdir(id, node, name) {
            this.sendRequest("/file/mkdir", { id: id, param: { node: node, name: name } }, (data) => {
                this.refresh();
                // GooglePhotos创建会话后选择照片
                const drive = this.getDrive(this.$store.state.curDriveId);
                const curNode = this.$store.state.curNode;
                const type = drive.type;
                if (type=="GooglePhotos" && curNode==null && data.id.startsWith("/session/")) {
                    const url = data.url;
                    window.open(url);
                }
            });
        },
        // 刷新当前目录
        refresh() {
            this.openFolder(
                this.$store.state.curDriveId,
                this.$store.state.curNode,
                null,
                true
            );
        },
        // 展开文件夹
        openFolder(id, node, start, forceLoad) {
            if (node && !node.dir) return;
            this.resetUploadDrag();
            this.cancelGridSelection();
            // 无论是网络请求还是缓存命中，均使此前尚未返回的请求失效。
            const requestId = ++this.expandRandom;
            const cachedFolder = !start && !forceLoad ? this.getFolderCache(id, node) : null;
            if (cachedFolder) {
                this.$store.state.curDriveId = id;
                this.$store.state.curNode = node;
                this.$store.state.curStart = cachedFolder.next;
                this.curResult = this.restoreCachedNodes(cachedFolder.nodes, node);
                this.curResultDriveId = id;
                this.fullscreenLoading = false;
                this.selectionAnchor = null;
                this.setFileSelection([]);
                return;
            }
            if (this.curResultDriveId != id) {
                this.curResult = [];
            }
            this.fullscreenLoading = true;
            this.sendRequest("/file/list", { id: id, param: { node: node, start: start } }, (data) => {
                if (this.expandRandom != requestId) return;
                this.$store.state.curDriveId = id;
                this.$store.state.curNode = node;
                this.$store.state.curStart = data.next;
                // 响应和缓存都只保存扁平节点；展示前才绑定当前父节点。
                let nodes = this.restoreCachedNodes(data.nodes || [], node);
                if (start) {
                    if (this.curResult.length + nodes.length > 1000) {
                        this.curResult = nodes;
                        Message.warning(this.$t('language.cloudExploer.tooManyFiles'));
                    } else {
                        this.curResult.push(...nodes);
                    }
                } else {
                    this.curResult = nodes;
                }
                this.curResultDriveId = id;
                this.setFolderCache(id, node, this.curResult, data.next);
                this.fullscreenLoading = false;
                this.selectionAnchor = null;
                this.setFileSelection([]);
            }, (res) => {
                if (this.expandRandom != requestId) return;
                if (this.curResultDriveId != id) {
                    this.curResult = [];
                }
                this.fullscreenLoading = false;
                this.selectionAnchor = null;
                this.setFileSelection([]);
                // GooglePhotos选择照片
                if (res.code == 500) {
                    const prefix = 'google_photos_v2_not_select:';
                    if (res.msg.startsWith(prefix)) {
                        const url = res.msg.substring(prefix.length);
                        window.open(url);
                    }
                }
            });
        },
        // 获取任务列表
        listTasks(callback) {
            this.sendRequest("/task/list", {}, (data) => {
                this.$store.state.tasks = data;
                if (callback) callback();
            })
        },
        // 不需要加载效果
        noLoading(path) {
            return ["/drive/info","/file/uploadProg","/file/upload","/file/delete","/file/list","/task/create"].includes(path) || path.indexOf("/lite/file/uploadFile")>=0;
        },
        // 发送Lite请求
        sendRequest(path, data, callback, errorCallback) {
            if (!this.noLoading(path)) {
                this.fullscreenLoading = true;
            }
            requestUtils.doLiteRequest(path, data)
                .then(res => {
                    if (!this.noLoading(path)) {
                        this.fullscreenLoading = false;
                    }
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data)
                        }
                    } else if (code == 400) {
                        // 请求失败
                        Message.warning(msg)
                        if (errorCallback) {
                            errorCallback(res)
                        }
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            if (path != "/drive/info") {
                                if (!msg.startsWith('google_photos_v2_not_select:')) {
                                    Message.error(msg)
                                }
                            }
                            if (errorCallback) {
                                errorCallback(res)
                            }
                        }
                    }
                }, err => {
                    if (!this.noLoading(path)) {
                        this.fullscreenLoading = false;
                    }
                    // 请求异常
                    Message.error(err)
                    if (errorCallback) {
                        errorCallback(err)
                    }
                });
        }
    }
}
</script>

<style scoped>
/* 文件管理 */
.lite-file {
    padding: 0px 20px;
    box-sizing: border-box;
    position: relative;
    top: 90px;
    height: calc(100% - 90px);
    background-color: #f2f7fe;
}

.lite-file-box {
    height: 100%;
}

.lite-file-drop-overlay {
    position: absolute;
    inset: 0 20px 36px;
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    box-sizing: border-box;
    border: 2px dashed #5562b4;
    border-radius: 6px;
    background: rgba(242, 247, 254, .94);
    color: #4350a2;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    overflow-wrap: anywhere;
    pointer-events: none;
}
.lite-file-drop-overlay > i { margin-bottom: 16px; font-size: 48px; }
.lite-file-drop-overlay.is-disabled { border-color: #a3a9b5; color: #6f7886; }

/* 文件列表 */
.lite-file-table {
    width: 100%;
    border: 1px solid #dce4f5;
    height: calc(100% - 116px) !important;
    user-select: none;
}

.lite-file-table >>>.el-table__body-wrapper {
    height: calc(100% - 43px) !important;
}

.lite-file-grid-view {
    height: calc(100% - 116px);
    display: flex;
    flex-direction: column;
    border: 1px solid #dce4f5;
    box-sizing: border-box;
    background: #fff;
    user-select: none;
}
.lite-file-grid-toolbar {
    min-height: 43px;
    padding: 6px 14px;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    box-sizing: border-box;
    border-bottom: 1px solid #edf0f6;
}
.lite-file-grid-toolbar >>> .el-checkbox { margin-right: auto; }
.lite-file-grid-sort {
    max-width: 40%;
    height: 30px;
    margin-left: 12px;
    padding: 0 8px;
    color: #606266;
    border: 1px solid #dce4f5;
    border-radius: 4px;
    background: #fff;
    outline: none;
}
.lite-file-grid-toolbar .lite-file-sort-direction {
    width: 30px;
    min-width: 30px;
    margin-left: 4px;
    padding: 0 !important;
    color: #5562b4;
    background: transparent;
    font-size: 18px;
}
.lite-file-sort-direction:disabled { opacity: .4; cursor: default; }
.lite-file-grid {
    position: relative;
    min-height: 0;
    flex: 1;
    overflow: auto;
    outline: none;
}
.lite-file-grid-items {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(132px, 1fr));
    gap: 12px;
    padding: 16px;
}
.lite-file-card {
    position: relative;
    min-width: 0;
    padding: 24px 10px 12px;
    border: 1px solid transparent;
    border-radius: 6px;
    box-sizing: border-box;
    text-align: center;
    cursor: default;
    color: #43506a;
}
.lite-file-card:hover { background: #f2f6fc; border-color: #dce4f5; }
.lite-file-card.is-selected { background: #e8eefc; border-color: #8495d8; }
.lite-file-card:focus-visible,
.file-view-toggle:focus-visible { outline: 2px solid #5562b4; outline-offset: -2px; }
.lite-file-card-checkbox {
    position: absolute;
    top: 8px;
    left: 8px;
    width: 16px;
    height: 16px;
    margin: 0;
    cursor: pointer;
    accent-color: #5562b4;
}
.lite-file-grid-icon {
    display: block;
    width: 64px;
    height: 64px;
    margin: 0 auto 12px;
    object-fit: contain;
    pointer-events: none;
}
.lite-file-card-name {
    height: 40px;
    line-height: 20px;
    font-size: 14px;
    overflow: hidden;
    overflow-wrap: anywhere;
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.lite-file-card-size { margin-top: 4px; font-size: 12px; line-height: 18px; color: #8a95a7; }
.lite-file-selection-box {
    position: absolute;
    z-index: 2;
    border: 1px solid #657bce;
    box-sizing: border-box;
    background: rgba(85, 98, 180, .15);
    pointer-events: none;
}

/* 文件夹导航主页 */
.folder-nav-home {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
    position: relative;
    top: -2px;
}

/* 文件夹导航 */
.folder-nav {
    height: 16px;
    line-height: 16px;
    margin-bottom: 6px;
    padding-top: 4px;
}

/* 文件夹导航项 */
.folder-nav-span {
    display: inline-block;
    vertical-align: middle;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
}

.folder-nav-span:hover {
    text-decoration: underline;
}

/* 文件图标 */
.lite-file-icon {
    width: 25px;
    height: 25px;
    margin-right: 10px;
}

/* 文件名 */
.lite-file-name {
    display: inline-block;
    height: 25px;
    line-height: 25px;
    vertical-align: middle;
    max-width: calc(100% - 30px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
}

.lite-file-name:hover {
    text-decoration: underline;
    color: #4350a2;
}

/* 加载中 */
.lite-file-loading {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 简洁圆环旋转动画 */
.lite-file-loading::after {
    content: "";
    width: 48px;
    height: 48px;
    border: 4px solid #DCE4F5;
    border-top-color: #5562B4;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.options-buttons-right {
    margin-bottom: 10px;
    height: 30px;
    float: right;
    display: flex;
    align-items: center;
    gap: 6px;
}

.options-buttons-right .file-view-toggle {
    width: 30px;
    min-width: 30px;
    height: 30px;
    padding: 0 !important;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #5562b4;
    font-size: 20px;
}
.options-buttons-right .file-view-toggle:hover { background: #cfd6e5; }

.options-buttons-right>div {
    padding: 5px;
    background-size: 20px;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 6px;
}

.options-buttons-right>div:hover {
    background-color: #cfd6e5;
}

/* 操作按钮 */
.options-buttons {
    height: 36px;
    margin-bottom: 10px;
    border: 1px solid transparent;
    display: inline-block;
    position: relative;
    left: -10px;
    max-width: calc(100% - 84px);
    box-sizing: border-box;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
}
.options-buttons::-webkit-scrollbar { height: 4px; }
.options-buttons::-webkit-scrollbar-thumb { background: #c3cce0; border-radius: 2px; }

.options-buttons.has-border {
    border: 1px solid #a7b4c8;
    left: 0px;
}

.btn-space {
    width: 1px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    background-color: #cdddf5;
}

.options-button {
    display: inline-block;
    cursor: pointer;
    margin-right: 5px;
    box-sizing: border-box;
    padding: 0 6px;
    border-radius: 4px;
}

.options-button-icon {
    width: 14px;
    height: 14px;
    display: inline-block;
    vertical-align: middle;
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
}

.lite-upload {
    background-image: url("../../assets/images/vectorImg/icon_Upload.svg");
}
.lite-bucket {
    background-image: url("../../assets/images/vectorImg/icon_add_floder.svg");
}
.lite-mkdir {
    background-image: url("../../assets/images/vectorImg/icon_add_floder.svg");
}
.lite-download {
    background-image: url("../../assets/images/vectorImg/icon_download.svg");
}
.lite-delete {
    background-image: url("../../assets/images/vectorImg/icon_Remove.svg");
}
.lite-rename {
    background-image: url("../../assets/images/vectorImg/icon_rename.svg");
}
.lite-preview {
    background-image: url("../../assets/images/vectorImg/icon_Preview.svg");
}
.lite-copy {
    background-image: url("../../assets/images/vectorImg/icon_Copy.svg");
}
.lite-cut {
    background-image: url("../../assets/images/vectorImg/icon_Cut.svg");
}
.lite-paste {
    background-image: url("../../assets/images/vectorImg/icon_Paste.svg");
}
.lite-tran-to {
    background-image: url("../../assets/images/menuIcon/black/cloud_taransfer_lite.svg");
}
.lite-sync-with {
    background-image: url("../../assets/images/menuIcon/black/cloud_sync_lite.svg");
}
.lite-backup-to {
    background-image: url("../../assets/images/menuIcon/black/cloud_backup_lite.svg");
}
.lite-next {
    background-image: url("../../assets/images/vectorImg/icon_Refresh.svg");
}

.options-button-text {
    color: #4350a2;
    font-size: 13px;
    display: inline-block;
    vertical-align: middle;
    line-height: 30px;
    height: 28px;
}

.options-button:hover>.options-button-text {
    text-decoration: underline;
}

/* 数据详情 */
.data-details {
    height: 26px;
    line-height: 26px;
    margin-top: 10px;
    color: #6f7886;
    font-size: 14px;
    user-select: none;
}

.data-details-count {
    display: inline-block;
    width: 190px;
    text-align: right;
}

.data-details-size {
    display: inline-block;
    margin-left: 100px;
}

/* 所有云盘 */
.lite-drive-box {
    height: 100%;
    overflow: auto;
    position: relative;
}

/* 云盘项 */
.lite-drive-item {
    width: calc(25% - 40px);
    min-width: 170px;
    height: 66px;
    box-sizing: border-box;
    border: 1px solid transparent;
    float: left;
    margin: 20px;
    cursor: pointer;
    position: relative;
}

.lite-drive-item:hover {
    border: 1px solid #a9baff;
    background-color: #eDf3fb;
}

.lite-drive-item-select {
    border: 1px solid #a9baff;
    background-color: #d9e7ff !important;
}

/* 云盘图标 */
.drive-item-icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    background-size: 24px;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: center;
    margin-top: 19px;
    margin-left: 20px;
}

/* 云盘信息 */
.drive-item-info {
    width: calc(100% - 55px);
    height: 100%;
    float: right;
}

/* 云盘名称 */
.drive-item-name {
    font-size: 14px;
    font-weight: bold;
    margin-top: 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 30px;
}

/* 云盘进度条 */
.drive-item-prog {
    box-sizing: border-box;
    height: 14px;
    border: 1px solid #a9baff;
    padding: 1px;
    margin: 5px 20px 5px 0px;
}

/* 云盘进度条进度 */
.drive-item-prog-item {
    width: 0%;
    height: 11px;
    background-color: #5166bd;
    max-width: 100%;
}

/* 容量 */
.drive-item-space {
    font-size: 12px;
}

/* 加载云盘信息 */
.drive-item-load {
    display: none;
    position: absolute;
    z-index: 1;
    right: 5px;
    top: 5px;
    font-size: 20px;
    font-weight: bold;
}

.lite-drive-item:hover .drive-item-load {
    display: block;
}

.lite-drive-footer {
    height: 30px;
    width: 100%;
    position: absolute;
    z-index: 1;
    bottom: 0px;
    left: 0px;
}

/* 打开上传列表图标 */
.upload-list-icon {
    float: right;
    margin-left: 20px;
    cursor: pointer;
    width: 26px;
    height: 26px;
    background-image: url("../../assets/images/vectorImg/icon_maximize.svg");
}

/* 上传列表 */
.upload-list-box {
    width: 500px;
    background-color: #FFF;
    position: absolute;
    z-index: 1;
    bottom: 45px;
    right: 20px;
    overflow: hidden;
    transition: height 0.3s ease;
}

/* 上传列表标题 */
.upload-list-title {
    height: 40px;
    line-height: 40px;
    background-color: #5562B4;
    border: 1px solid #5562B4;
    color: #FFF;
    text-indent: 10px;
}

/* 上传列表关闭图标 */
.upload-list-close {
    float: right;
    margin-top: 10px;
    margin-right: 10px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    background-image: url("../../assets/images/vectorImg/icon_minimize.svg");
}

.upload-list-items {
    height: 201px;
    overflow: auto;
    border: 1px solid #5562B4;
}

.upload-list-item {
    height: 40px;
    line-height: 40px;
}

.upload-list-item:hover {
    background-color: #d9e7ff;
}

.upload-list-item:hover>.el-icon-top {
    display: none;
}

.upload-list-item>.el-icon-circle-close {
    display: none;
}

.upload-list-item:hover>.el-icon-circle-close {
    display: inline-block;
    cursor: pointer;
}

.upload-list-item>* {
    display: inline-block;
    vertical-align: middle;
}

.upload-list-item>i {
    font-size: 20px;
}

.upload-list-name {
    width: 365px;
    margin-left: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.upload-list-size {
    width: 80px;
}

.copy_nodes {
    width: 400px;
    max-height: 300px;
    overflow: auto;
    cursor: default;
    color: #606266;
    user-select: none;
}
.copy_node_index {
    color: #5562B4;
    height: 30px;
    line-height: 30px;
    width: 50px;
    display: inline-block;
    vertical-align: middle;
}
.copy_node_name {
    height: 30px;
    line-height: 30px;
    display: inline-block;
    width: 250px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
}
.copy_node_size {
    height: 30px;
    line-height: 30px;
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 10px;
    vertical-align: middle;
}

.addCloudIconLite {
    width: auto;
    height: 30px;
    text-indent: 30px;
    background-repeat: no-repeat;
    background-position: 10px 3px;
}
.lite-drive-box-btns {
    padding-top: 30px;
    padding-bottom: 20px;
}
.lite-drive-items {
    border: 1px solid #d6e4f7;
    background-color: #FFF;
    height: calc(100% - 40px);
    overflow: auto;
}
.lite-drive-item-line {
    height: 1px;
    width: calc(100% - 40px);
    background-color: #f1f1f1;
    clear: both;
    margin: 0 auto;
}
.lite-drive-item-no-space {
    width: 152px;
    text-align: center;
}
.lite-drive-item-no-space>.drive-item-icon {
    margin-left: 0px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.lite-drive-item-no-space>.drive-item-name {
    margin-top: 0px;
    margin-right: 0px;
    font-weight: normal;
    width: 142px;
    margin: 0 auto;
}
.drive-count {
    display: inline-block;
    line-height: 30px;
    height: 30px;
    width: 24%;
    color: #6f7886;
    size: 14px;
}
.right-menus {
    user-select: none;
    border: 1px solid #8a96e3;
    background: #fff;
    position: fixed;
    z-index: 10;
    left: 0px;
    top: 0px;
}
.right-menus>.options-button {
    display: block;
    height: 29px;
    line-height: 29px;
    font-size: 14px;
    min-width: 130px;
    padding: 0px 15px;
    margin-right: 0px;
    border-radius: 0px;
}
.right-menus>.options-button:hover {
    background-color: #ebf3fe;
}
.right-menus>.options-button>.options-button-text {
    margin-left: 10px;
}
.right-menus>.options-button:hover>.options-button-text {
    text-decoration: none;
}
</style>
<style>
.el-checkbox__input.is-indeterminate .el-checkbox__inner,
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #5562B4;
  border-color: #5562B4;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #5562B4;
}
.lite-file-table.el-table .el-table__cell.is-center {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/lite_file.vue